// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ========================================
   RESPONSIVE POPUP COMPONENTS STYLES
   ======================================== */
/* Base responsive container for all popup dialogs */
.responsive-popup-container {
  padding: 0 !important;
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;
  width: 100%;
  height: 100%;
}

/* Base responsive box for popup content */
.responsive-popup-box {
  max-width: 560px;
  width: 100% !important;
  margin: 10px;
  padding: 0px 25px;
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 15px 15px 0px 0px;
  margin: 0px auto;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-size: 100% 90%;
  background-position: top center;
  opacity: 1 !important;
  -webkit-backdrop-filter: none !important;
          backdrop-filter: none !important;
}

/* Responsive header styles */
.responsive-popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: -25px;
  margin-right: -25px;
  padding: 12px 16px;
  background: #fff !important;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
  position: relative;
  min-height: 60px;
}
.responsive-popup-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 1.3;
}
.responsive-popup-header .header-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #333;
  background: transparent !important;
  border: none !important;
  box-shadow: none;
}

/* Responsive close button */
.responsive-popup-close {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #212427;
  opacity: 1 !important;
  z-index: 10;
  cursor: pointer;
  background: transparent;
  border: none;
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}
.responsive-popup-close:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.responsive-popup-close .close-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

/* Responsive content area */
.responsive-popup-content {
  flex: 1;
  overflow-y: auto;
  background: #fff !important;
  padding: 24px;
  -webkit-overflow-scrolling: touch;
}

/* Responsive box wrapper */
.responsive-popup-box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  flex-wrap: wrap;
}

/* Responsive description box */
.responsive-popup-des-box {
  background: #fff;
  position: relative;
  width: 100%;
}
.responsive-popup-des-box::after {
  content: "";
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 0px !important;
  position: absolute;
  top: 0;
  z-index: -1;
  left: 0;
  right: 0;
}

/* Responsive title box */
.responsive-popup-title-box {
  padding: 0px 0px 60px 0px;
  width: 100%;
}
.responsive-popup-title-box h2 {
  color: #fff !important;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 20px;
  text-align: left;
}
.responsive-popup-title-box ul {
  margin: 0px;
  padding: 0px;
}
.responsive-popup-title-box ul li {
  color: #fff;
  list-style: none;
  padding: 8px 10px 8px 0px;
  font-size: 16px;
  text-align: left;
}
.responsive-popup-title-box ul li span {
  margin-right: 8px;
}

/* Responsive dialog actions */
.responsive-popup-actions {
  padding: 16px 20px;
  min-height: 60px;
  position: sticky;
  bottom: 0;
  background: #f8f9fa;
  border-top: 1px solid #e0e0e0;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: visible;
  overflow-y: hidden;
}
.responsive-popup-actions button {
  min-height: 48px;
  min-width: 120px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
  border: none;
  cursor: pointer;
}
.responsive-popup-actions button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.responsive-popup-actions button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.responsive-popup-actions .cancel-btn {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
}
.responsive-popup-actions .cancel-btn:hover:not(:disabled) {
  background: #e8e8e8;
}
.responsive-popup-actions .primary-btn {
  background: #5ea1d8;
  color: white;
}
.responsive-popup-actions .primary-btn:hover:not(:disabled) {
  background: #4a8bc2;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.3);
}
.responsive-popup-actions .success-btn {
  background: #28a745;
  color: white;
}
.responsive-popup-actions .success-btn:hover:not(:disabled) {
  background: #218838;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}
.responsive-popup-actions .danger-btn {
  background: #dc3545;
  color: white;
}
.responsive-popup-actions .danger-btn:hover:not(:disabled) {
  background: #c82333;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

/* ========================================
   MOBILE RESPONSIVE BREAKPOINTS
   ======================================== */
/* Tablet and below (768px and below) */
@media (max-width: 768px) {
  .responsive-popup-container {
    max-height: 95vh !important;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .responsive-popup-box {
    max-width: 95vw !important;
    width: 95vw !important;
    margin: 2.5vh auto !important;
    padding: 0px 15px !important;
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    max-height: 90vh !important;
    border-radius: 8px;
  }
  .responsive-popup-header {
    padding: 16px 20px;
    min-height: 60px;
  }
  .responsive-popup-header h2 {
    font-size: 18px;
    line-height: 1.3;
  }
  .responsive-popup-header .header-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .responsive-popup-close {
    min-width: 44px;
    min-height: 44px;
    padding: 8px;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }
  .responsive-popup-close .close-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
  }
  .responsive-popup-content {
    padding: 20px;
    max-height: calc(95vh - 140px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .responsive-popup-actions {
    padding: 16px 20px;
    min-height: 60px;
    position: sticky;
    bottom: 0;
    background: #f8f9fa;
    border-top: 1px solid #e0e0e0;
    display: flex;
    gap: 12px;
    justify-content: center;
    align-items: center;
  }
  .responsive-popup-actions button {
    min-height: 48px;
    min-width: 120px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    padding: 12px 20px;
  }
  .responsive-popup-actions button mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}
/* Small mobile devices (480px and below) */
@media (max-width: 480px) {
  .responsive-popup-container {
    max-height: 95vh !important;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .responsive-popup-box {
    max-width: 98vw !important;
    width: 98vw !important;
    margin: 2.5vh auto !important;
    padding: 0px 12px !important;
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    border-radius: 6px;
  }
  .responsive-popup-header {
    padding: 12px 16px;
    min-height: 56px;
  }
  .responsive-popup-header h2 {
    font-size: 16px;
    line-height: 1.3;
  }
  .responsive-popup-header .header-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
  .responsive-popup-close {
    min-width: 44px;
    min-height: 44px;
    padding: 10px;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }
  .responsive-popup-close .close-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .responsive-popup-content {
    padding: 16px;
    max-height: calc(98vh - 120px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .responsive-popup-actions {
    padding: 12px 16px;
    min-height: 56px;
    position: sticky;
    bottom: 0;
    background: #f8f9fa;
    border-top: 1px solid #e0e0e0;
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
  }
  .responsive-popup-actions button {
    min-height: 44px;
    min-width: 100px;
    font-size: 13px;
    padding: 10px 16px;
  }
  .responsive-popup-actions button mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
}
/* ========================================
   LANDSCAPE ORIENTATION SUPPORT
   ======================================== */
/* Mobile landscape orientation */
@media (max-width: 768px) and (orientation: landscape) {
  .responsive-popup-container {
    max-height: 100vh !important;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .responsive-popup-box {
    max-height: 95vh !important;
    width: 98vw !important;
    max-width: 98vw !important;
    margin: 1vh auto !important;
    -webkit-overflow-scrolling: touch;
  }
  .responsive-popup-content {
    max-height: calc(95vh - 120px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .responsive-popup-actions {
    padding: 12px 16px;
    min-height: 50px;
    position: sticky;
    bottom: 0;
  }
}
/* ========================================
   ACCESSIBILITY IMPROVEMENTS
   ======================================== */
/* Focus management for better accessibility */
.responsive-popup-container *:focus-visible {
  outline: 2px solid #5ea1d8 !important;
  outline-offset: 2px !important;
}
.responsive-popup-container .restricted-tab-bar button:focus,
.responsive-popup-container .restricted-tab-bar button:focus-visible,
.responsive-popup-container .restricted-tab-bar button:active {
  outline: none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
}
.responsive-popup-container button, .responsive-popup-container .clickable {
  -webkit-tap-highlight-color: rgba(94, 161, 216, 0.2);
  transition: all 0.2s ease;
}
.responsive-popup-container button, .responsive-popup-container .clickable {
  -webkit-user-select: none;
  user-select: none;
}
.responsive-popup-container .responsive-popup-content {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

/* ========================================
   DARK MODE SUPPORT
   ======================================== */
/* Use body.theme-dark directly — more reliable than :host-context
   for Material Dialog content that renders outside the component tree. */
body.theme-dark .responsive-popup-box {
  background: #111827 !important;
  color: #e2e8f0 !important;
}

body.theme-dark .responsive-popup-header {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .responsive-popup-content {
  background: #111827 !important;
  color: #e2e8f0 !important;
}

body.theme-dark .responsive-popup-des-box {
  background: #111827 !important;
  color: #e2e8f0 !important;
}

body.theme-dark .responsive-popup-des-box::after,
body.theme-dark .responsive-popup-des-box::before {
  background: #111827 !important;
}

body.theme-dark .responsive-popup-actions {
  background: #1f2937 !important;
  border-top-color: rgba(148, 163, 184, 0.2) !important;
}

/* ========================================
   HIGH CONTRAST SUPPORT
   ======================================== */
@media (prefers-contrast: high) {
  .responsive-popup-box {
    border: 2px solid #000000;
  }
  .responsive-popup-header {
    border-bottom: 2px solid #000000;
  }
  .responsive-popup-actions {
    border-top: 2px solid #000000;
  }
}
/* ========================================
   REDUCED MOTION SUPPORT
   ======================================== */
@media (prefers-reduced-motion: reduce) {
  .responsive-popup-container * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
/* ========================================
   FORM ELEMENTS RESPONSIVE STYLES
   ======================================== */
.responsive-form-field {
  width: 100%;
  margin-bottom: 16px;
}
.responsive-form-field input, .responsive-form-field textarea, .responsive-form-field select {
  width: 100%;
  min-height: 44px;
  font-size: 16px;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  transition: border-color 0.2s ease;
  -webkit-appearance: none;
  appearance: none;
}
.responsive-form-field input:focus, .responsive-form-field textarea:focus, .responsive-form-field select:focus {
  outline: none;
  border-color: #5ea1d8;
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);
}
.responsive-form-field input::placeholder, .responsive-form-field textarea::placeholder, .responsive-form-field select::placeholder {
  color: #999;
}
.responsive-form-field textarea {
  min-height: 80px;
  resize: vertical;
  font-family: inherit;
}

/* ========================================
   LIST AND SELECTION RESPONSIVE STYLES
   ======================================== */
.responsive-list .list-item {
  min-height: 60px;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}
.responsive-list .list-item:hover {
  background-color: #f8f9fa;
}
.responsive-list .list-item.selected {
  background-color: #e3f2fd;
  border-left: 4px solid #5ea1d8;
}
.responsive-list .list-item .item-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.responsive-list .list-item .item-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.responsive-list .list-item .item-avatar .avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #5ea1d8 0%, #56baed 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
}
.responsive-list .list-item .item-content {
  flex: 1;
  min-width: 0;
}
.responsive-list .list-item .item-content .item-title {
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  font-size: 16px;
  line-height: 1.4;
}
.responsive-list .list-item .item-content .item-subtitle {
  color: #666;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ========================================
   PAGINATION RESPONSIVE STYLES
   ======================================== */
.responsive-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 0;
  border-top: 1px solid #e0e0e0;
  margin-top: 16px;
}
.responsive-pagination .nav-btn {
  min-width: 44px;
  min-height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid #e0e0e0;
  color: #666;
  transition: all 0.2s ease;
}
.responsive-pagination .nav-btn:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #ccc;
}
.responsive-pagination .nav-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.responsive-pagination .nav-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.responsive-pagination .page-numbers {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: center;
}
.responsive-pagination .page-numbers .page-btn {
  min-width: 44px;
  min-height: 44px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #e0e0e0;
  background: white;
  color: #666;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.responsive-pagination .page-numbers .page-btn:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #ccc;
}
.responsive-pagination .page-numbers .page-btn.active {
  background: #5ea1d8;
  color: white;
  border-color: #5ea1d8;
}
.responsive-pagination .page-numbers .page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ========================================
   LOADING AND EMPTY STATES
   ======================================== */
.responsive-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  color: #666;
  font-size: 14px;
}
.responsive-loading mat-spinner {
  margin-right: 8px;
}

.responsive-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
}
.responsive-empty mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #ccc;
}

/* ========================================
   UTILITY CLASSES
   ======================================== */
.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.d-flex {
  display: flex;
}

.d-block {
  display: block;
}

.d-none {
  display: none;
}

.align-items-center {
  align-items: center;
}

.justify-content-center {
  justify-content: center;
}

.justify-content-between {
  justify-content: space-between;
}

.justify-content-end {
  justify-content: flex-end;
}

.w-100 {
  width: 100%;
}

.h-100 {
  height: 100%;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-1 {
  margin-bottom: 8px;
}

.mb-2 {
  margin-bottom: 16px;
}

.mb-3 {
  margin-bottom: 24px;
}

.mt-0 {
  margin-top: 0;
}

.mt-1 {
  margin-top: 8px;
}

.mt-2 {
  margin-top: 16px;
}

.mt-3 {
  margin-top: 24px;
}

.p-0 {
  padding: 0;
}

.p-1 {
  padding: 8px;
}

.p-2 {
  padding: 16px;
}

.p-3 {
  padding: 24px;
}

.font-weight-bold {
  font-weight: bold;
}

.font-weight-normal {
  font-weight: normal;
}

.text-muted {
  color: #666;
}

.text-primary {
  color: #5ea1d8;
}

.text-success {
  color: #28a745;
}

.text-danger {
  color: #dc3545;
}

.text-warning {
  color: #ffc107;
}

/* ── Dark mode overrides ─────────────────────────────────────
   Use body.theme-dark (not :host-context) so rules apply to
   Material Dialog content rendered in the CDK overlay.
   ──────────────────────────────────────────────────────────── */
body.theme-dark .enhanced-restricted-access-dialog {
  /* Selected users chips (inside .selection-menu) */
  /* Chip container — dark bg with readable text */
  /* Chip text label (Material renders text inside a span inside the chip) */
  /* Chip remove (×) button */
}
body.theme-dark .enhanced-restricted-access-dialog .selection-option {
  background: #1a2332 !important;
  color: #e2e8f0 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .selection-option:hover,
body.theme-dark .enhanced-restricted-access-dialog .selection-option.mat-radio-checked {
  background: #253347 !important;
  color: #e2e8f0 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .selection-menu h3 {
  color: #e2e8f0 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .option-text strong {
  color: #e2e8f0 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .option-text p {
  color: #94a3b8 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .selection-menu .selected-users {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
body.theme-dark .enhanced-restricted-access-dialog .selected-users mat-chip-option,
body.theme-dark .enhanced-restricted-access-dialog .selected-users .mat-mdc-chip,
body.theme-dark .enhanced-restricted-access-dialog .selected-users .mdc-evolution-chip {
  background: #1e3a5f !important;
  background-color: #1e3a5f !important;
  color: #e2e8f0 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .selected-users mat-chip-option:hover,
body.theme-dark .enhanced-restricted-access-dialog .selected-users .mat-mdc-chip:hover,
body.theme-dark .enhanced-restricted-access-dialog .selected-users .mdc-evolution-chip:hover {
  background: #26487a !important;
}
body.theme-dark .enhanced-restricted-access-dialog .selected-users .mdc-evolution-chip__text-label,
body.theme-dark .enhanced-restricted-access-dialog .selected-users .mat-mdc-chip-action-label {
  color: #e2e8f0 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .selected-users .mat-mdc-chip-remove mat-icon,
body.theme-dark .enhanced-restricted-access-dialog .selected-users .mat-mdc-chip-remove .mat-icon {
  color: #94a3b8 !important;
  opacity: 1 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .search-input {
  background: #1f2937 !important;
  color: #f8fafc !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
body.theme-dark .enhanced-restricted-access-dialog .search-icon {
  color: #94a3b8 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .users-section .section-header h3 {
  color: #e2e8f0 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .users-section .pagination-info {
  background: #1f2937 !important;
  color: #94a3b8 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .users-section .selected-users {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
body.theme-dark .enhanced-restricted-access-dialog .users-section .selected-users h4 {
  color: #e2e8f0 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .users-section .user-option:hover {
  background-color: #253347 !important;
  background: #253347 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .users-section .user-option:hover .user-name {
  color: #e2e8f0 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .users-section .user-option:hover .user-email {
  color: #94a3b8 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .users-section .user-option:hover mat-icon {
  color: #e2e8f0 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .users-section .user-name {
  color: #e2e8f0 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .users-section .user-email,
body.theme-dark .enhanced-restricted-access-dialog .users-section .searching-users,
body.theme-dark .enhanced-restricted-access-dialog .users-section .no-users {
  color: #94a3b8 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .page-btn {
  background: #1f2937 !important;
  color: #94a3b8 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
body.theme-dark .enhanced-restricted-access-dialog .page-btn:hover:not(:disabled) {
  background: #2d3748 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .page-btn.active {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  border-color: #5ea1d8 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .create-flow-notice {
  background: #1a2c3d !important;
  border-color: rgba(94, 161, 216, 0.4) !important;
  color: #7ec8f0 !important;
}

/* Fix padding for enhanced-restricted-access dialog (standalone popup only) */
.enhanced-restricted-access-dialog:not(.embedded-access) .responsive-popup-container {
  padding: 0 !important;
}
.enhanced-restricted-access-dialog:not(.embedded-access) .responsive-popup-box {
  padding: 0px 25px !important;
}
.enhanced-restricted-access-dialog:not(.embedded-access) .responsive-popup-content {
  padding: 16px 24px !important;
  min-height: 200px;
  text-align: left;
}
.enhanced-restricted-access-dialog:not(.embedded-access) .responsive-popup-box-wrap {
  padding: 0 !important;
  text-align: left;
}
.enhanced-restricted-access-dialog:not(.embedded-access) .responsive-popup-des-box {
  padding: 0 !important;
  text-align: left;
}
.enhanced-restricted-access-dialog:not(.embedded-access) .analytics-title,
.enhanced-restricted-access-dialog:not(.embedded-access) .analytics-title h2,
.enhanced-restricted-access-dialog:not(.embedded-access) .selection-menu,
.enhanced-restricted-access-dialog:not(.embedded-access) .selection-menu h3,
.enhanced-restricted-access-dialog:not(.embedded-access) .advanced-access-header,
.enhanced-restricted-access-dialog:not(.embedded-access) .advanced-access-header h3,
.enhanced-restricted-access-dialog:not(.embedded-access) .advanced-access-hint,
.enhanced-restricted-access-dialog:not(.embedded-access) .users-advanced-nudge,
.enhanced-restricted-access-dialog:not(.embedded-access) .advanced-access-info-panel,
.enhanced-restricted-access-dialog:not(.embedded-access) .field-label,
.enhanced-restricted-access-dialog:not(.embedded-access) .field-help,
.enhanced-restricted-access-dialog:not(.embedded-access) .section-header,
.enhanced-restricted-access-dialog:not(.embedded-access) .tab-pane {
  text-align: left;
}

/* Match Transfer Ownership styles for users list */
.search-section {
  margin-bottom: 24px;
}
.search-section .search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.search-section .search-input-wrapper .search-icon {
  position: absolute;
  left: 12px;
  color: #666;
  z-index: 1;
}
.search-section .search-input-wrapper .search-input {
  width: 100%;
  padding: 12px 12px 12px 44px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  font-family: "Raleway", sans-serif;
  font-weight: 500;
  transition: border-color 0.2s ease;
}
.search-section .search-input-wrapper .search-input:focus {
  outline: none;
  border-color: #5ea1d8;
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);
}
.search-section .search-input-wrapper .search-input::placeholder {
  color: #999;
  font-family: "Raleway", sans-serif;
  font-weight: 500;
}

/* Clean selection menu to avoid gray block - Match profile menu style */
.selection-menu {
  background: transparent;
  border: 0;
  border-radius: 0;
  padding: 0 0 16px 0;
  margin: 0 0 12px 0;
  box-shadow: none;
}
.selection-menu.access-mode-menu {
  padding-bottom: 8px;
  margin-bottom: 4px;
}
.selection-menu.access-mode-menu h3 {
  margin-bottom: 8px;
  font-size: 14px;
}
.selection-menu.access-mode-menu .access-mode-radios {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 20px;
  width: auto;
  padding: 5px;
}
.selection-menu.access-mode-menu ::ng-deep .access-mode-radios .mat-mdc-radio-button {
  margin: 0;
  padding: 5px;
}
.selection-menu.access-mode-menu ::ng-deep .access-mode-radios .mat-mdc-radio-button .mdc-form-field {
  gap: 4px;
}
.selection-menu.access-mode-menu ::ng-deep .access-mode-radios .mat-mdc-radio-button .mdc-label {
  padding-left: 0;
  margin: 0;
  font-family: "Raleway", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
}
.selection-menu h3 {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 500;
  font-family: "Raleway", sans-serif;
  color: #333;
  text-align: left;
}
.selection-menu mat-radio-group {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 5px;
}

.selection-option {
  display: block;
  width: 100%;
  margin-bottom: 5px;
  padding: 5px;
  background: #fff;
  border-radius: 0;
  border: none;
  border-left: 2px solid transparent;
  transition: all 0.5s ease-in-out;
  position: relative;
  font-family: "Raleway", sans-serif;
  font-weight: 500;
}
.selection-option:before {
  content: "";
  width: 2px;
  height: 100%;
  top: 0px;
  left: 0px;
  background: #5ea1d8;
  position: absolute;
  transition: width 0.5s ease-in-out;
  z-index: -1;
}

/* Ensure the dialog surface remains fully vivid and clickable like the comment popup */
::ng-deep .cdk-overlay-pane.dialoguebox .mat-mdc-dialog-container,
::ng-deep .cdk-overlay-pane.dialoguebox .mat-mdc-dialog-surface {
  opacity: 1 !important;
  pointer-events: auto !important;
  filter: none !important;
  padding: 0 !important;
}

/* Ensure the enhanced-restricted-access dialog has proper padding and matches profile menu style */
::ng-deep .cdk-overlay-pane.dialoguebox .enhanced-restricted-access-dialog {
  font-family: "Raleway", sans-serif;
}
::ng-deep .cdk-overlay-pane.dialoguebox .enhanced-restricted-access-dialog .responsive-popup-container {
  padding: 0 !important;
}
::ng-deep .cdk-overlay-pane.dialoguebox .enhanced-restricted-access-dialog .responsive-popup-content {
  padding: 24px !important;
  font-family: "Raleway", sans-serif;
}
::ng-deep .cdk-overlay-pane.dialoguebox .enhanced-restricted-access-dialog .responsive-popup-header h2 {
  font-family: "Raleway", sans-serif;
  font-weight: 500;
}
::ng-deep .cdk-overlay-pane.dialoguebox .enhanced-restricted-access-dialog button, ::ng-deep .cdk-overlay-pane.dialoguebox .enhanced-restricted-access-dialog span, ::ng-deep .cdk-overlay-pane.dialoguebox .enhanced-restricted-access-dialog p, ::ng-deep .cdk-overlay-pane.dialoguebox .enhanced-restricted-access-dialog h3, ::ng-deep .cdk-overlay-pane.dialoguebox .enhanced-restricted-access-dialog h4, ::ng-deep .cdk-overlay-pane.dialoguebox .enhanced-restricted-access-dialog div, ::ng-deep .cdk-overlay-pane.dialoguebox .enhanced-restricted-access-dialog input, ::ng-deep .cdk-overlay-pane.dialoguebox .enhanced-restricted-access-dialog label {
  font-family: "Raleway", sans-serif;
}

.selection-option:hover {
  color: #fff;
  background: #fff;
}
.selection-option:hover:before {
  width: 100%;
}

.selection-option.mat-radio-checked {
  color: #fff;
  background: #fff;
}
.selection-option.mat-radio-checked:before {
  width: 100%;
}

.option-content {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  font-family: "Raleway", sans-serif;
  font-weight: 500;
}

.option-icon {
  font-size: 22px;
  color: #5ea1d8;
}

::ng-deep .enhanced-restricted-access-dialog mat-radio-group,
::ng-deep .enhanced-restricted-access-dialog .mat-mdc-radio-group {
  padding: 5px;
}
::ng-deep .enhanced-restricted-access-dialog .mat-mdc-radio-button {
  padding: 5px;
}
::ng-deep .enhanced-restricted-access-dialog .mat-mdc-radio-button .mdc-form-field .mdc-form-field__label {
  font-family: "Raleway", sans-serif;
  font-weight: 500;
}
::ng-deep .enhanced-restricted-access-dialog mat-radio-button {
  font-family: "Raleway", sans-serif;
  font-weight: 500;
  padding: 5px;
}

.option-text strong {
  display: block;
  width: 100%;
  text-align: left;
  font-size: 15px;
  font-weight: 500;
  font-family: "Raleway", sans-serif;
  margin-bottom: 4px;
  color: #333;
}

.option-text p {
  margin: 0;
  text-align: left;
  font-size: 13px;
  font-family: "Raleway", sans-serif;
  font-weight: 500;
  color: #666;
}

.users-section {
  font-family: "Raleway", sans-serif;
}
.users-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.users-section .section-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  font-family: "Raleway", sans-serif;
  color: #333;
}
.users-section .section-header .pagination-info {
  font-size: 12px;
  font-family: "Raleway", sans-serif;
  font-weight: 500;
  color: #666;
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 12px;
}
.users-section .selected-users {
  margin-bottom: 20px;
  padding: 16px;
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}
.users-section .selected-users h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 500;
  font-family: "Raleway", sans-serif;
  color: #333;
}
.users-section .selected-users mat-chip-listbox {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.users-section .selected-users mat-chip-option {
  background: #d8e4f7;
  color: #1a3a6b;
  font-size: 12px;
}
.users-section .selected-users mat-chip-option:hover {
  background: #b8ccee;
}
.users-section .selected-users mat-chip-option .mat-mdc-chip-remove {
  color: #1a3a6b;
  opacity: 0.7;
}
.users-section .selected-users mat-chip-option .mat-mdc-chip-remove:hover {
  opacity: 1;
}
.users-section .searching-users {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  color: #666;
}
.users-section .no-users {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  color: #999;
}
.users-section .users-list {
  margin-bottom: 16px;
}
.users-section .users-list .user-option {
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background-color 0.2s ease;
}
.users-section .users-list .user-option:hover {
  background-color: #eef2f7;
}
.users-section .users-list .user-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  min-width: 0;
}
.users-section .users-list .user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.users-section .users-list .avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.users-section .users-list .avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #5ea1d8 0%, #56baed 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
}
.users-section .users-list .user-info {
  flex: 1;
  min-width: 0;
}
.users-section .users-list .user-name {
  font-weight: 500;
  font-family: "Raleway", sans-serif;
  color: #333;
  margin-bottom: 2px;
  font-size: 14px;
}
.users-section .users-list .user-email {
  font-family: "Raleway", sans-serif;
  font-weight: 500;
  color: #666;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.users-section .pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}
.users-section .nav-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.users-section .nav-btn:hover {
  background: #f5f5f5;
}
.users-section .nav-btn:disabled:hover {
  background: transparent;
}
.users-section .page-numbers {
  display: flex;
  gap: 4px;
}
.users-section .page-btn {
  min-width: 32px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 500;
  font-family: "Raleway", sans-serif;
  border: 1px solid #e0e0e0;
  background: #fff;
  color: #666;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.users-section .page-btn:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #ccc;
}
.users-section .page-btn.active {
  background: #5ea1d8;
  color: #fff;
  border-color: #5ea1d8;
}

/* Link Access Info Section - Match profile menu style */
.link-access-info {
  font-family: "Raleway", sans-serif;
  margin-bottom: 16px;
}
.link-access-info .info-content h4 {
  font-family: "Raleway", sans-serif;
  font-weight: 500;
  color: #333;
}
.link-access-info .info-content p {
  font-family: "Raleway", sans-serif;
  font-weight: 500;
  color: #666;
}

/* Footer actions — match create-flow Publish (.btn-primary) */
.enhanced-restricted-access-dialog.responsive-popup-container {
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.enhanced-restricted-access-dialog .responsive-popup-box {
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.enhanced-restricted-access-dialog .responsive-popup-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
.enhanced-restricted-access-dialog .responsive-popup-actions {
  flex-shrink: 0;
  position: relative;
  z-index: 6;
  justify-content: flex-end;
}
.enhanced-restricted-access-dialog .responsive-popup-actions .btn.btn-primary,
.enhanced-restricted-access-dialog .responsive-popup-actions .btn-primary {
  min-height: auto;
  min-width: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.current-access-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0 0 16px 0;
  padding: 12px 14px;
  border-radius: 10px;
  background: #eef6fc;
  border: 1px solid rgba(94, 161, 216, 0.45);
}

.current-access-icon {
  color: #1976d2;
  margin-top: 2px;
}

.current-access-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.current-access-copy .current-access-kicker {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #1976d2;
}
.current-access-copy strong {
  font-size: 15px;
  color: #0f172a;
}
.current-access-copy p {
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: #475569;
}

body.theme-dark .enhanced-restricted-access-dialog .current-access-banner {
  background: #1a2c3d !important;
  border-color: rgba(94, 161, 216, 0.4) !important;
}
body.theme-dark .enhanced-restricted-access-dialog .current-access-icon,
body.theme-dark .enhanced-restricted-access-dialog .current-access-copy .current-access-kicker {
  color: #7ec8f0 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .current-access-copy strong {
  color: #e2e8f0 !important;
}
body.theme-dark .enhanced-restricted-access-dialog .current-access-copy p {
  color: #94a3b8 !important;
}

.header-saved-access {
  display: none;
}

@media (max-width: 768px) {
  .current-access-banner {
    align-items: center;
    gap: 10px;
    margin: 0 0 14px 0;
    padding: 10px 12px;
    border-radius: 12px;
  }
  .current-access-copy strong {
    font-size: 14px;
  }
  .current-access-copy p {
    font-size: 12px;
  }
}
/* Create Flow Mode Notice */
.create-flow-notice {
  background: #e3f2fd;
  border: 1px solid #5ea1d8;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-family: "Raleway", sans-serif;
  font-weight: 500;
  color: #1976d2;
}
.create-flow-notice .notice-icon {
  color: #5ea1d8;
  font-size: 18px;
  width: 18px;
  height: 18px;
}

/* Title Section */
.title-section {
  text-align: center;
  margin-bottom: 20px;
}
.title-section h2 {
  color: #333;
  margin-bottom: 8px;
  font-size: 24px;
  font-weight: 600;
}
.title-section p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

/* Search Section */
.search-section {
  margin-bottom: 20px;
}
.search-section .search-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
}
.search-section .search-input:focus {
  border-color: #5ea1d8;
}
.search-section .search-input::placeholder {
  color: #999;
}

/* Users Section */
.users-section {
  margin-bottom: 20px;
}
.users-section .user-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
}
.users-section .user-item:hover {
  background-color: #f8f9fa;
}
.users-section .user-item .transfer-checkbox {
  margin-right: 16px;
}
.users-section .user-item .user-avatar {
  margin-right: 16px;
  cursor: pointer;
}
.users-section .user-item .user-avatar .avatar-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.users-section .user-item .user-avatar .avatar-placeholder {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.users-section .user-item .user-avatar .avatar-placeholder .material-icons {
  font-size: 24px;
  color: #666;
}
.users-section .user-item .user-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.users-section .user-item .user-info .user-name {
  font-weight: 600;
  color: #333;
  font-size: 16px;
}
.users-section .user-item .user-info .user-username {
  color: #666;
  font-size: 14px;
}
.users-section .user-item .user-info .user-email {
  color: #999;
  font-size: 12px;
}

/* Loading Section */
.loading-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 20px;
  color: #666;
}
.loading-section mat-spinner {
  margin-right: 8px;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}
.action-buttons .cancel-btn {
  color: #666;
}
.action-buttons .confirm-btn {
  background-color: #5ea1d8;
  color: white;
}
.action-buttons .confirm-btn:disabled {
  background-color: #ccc;
  color: #666;
}

.or-access-hint {
  margin: 0 0 6px;
  font-size: 0.875rem;
  opacity: 0.9;
  line-height: 1.35;
  text-align: left;
}

.feature-info-btn {
  border: none;
  background: transparent;
  padding: 0;
  margin: 0 4px 0 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  cursor: pointer;
  color: #5ea1d8;
  outline: none !important;
  box-shadow: none !important;
  width: 16px;
  height: 16px;
  min-width: 16px;
  line-height: 1;
  position: relative;
  top: -1px;
}
.feature-info-btn mat-icon {
  width: 16px !important;
  height: 16px !important;
  font-size: 16px !important;
  line-height: 16px !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden;
}
.feature-info-btn:hover {
  color: #4a8fc4;
}
.feature-info-btn:focus, .feature-info-btn:focus-visible, .feature-info-btn:active {
  outline: none !important;
  box-shadow: none !important;
}

.advanced-access-info-panel {
  margin: 0 0 8px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid rgba(94, 161, 216, 0.35);
  background: #eef6fc;
  font-size: 0.84rem;
  line-height: 1.35;
  color: #334155;
}
.advanced-access-info-panel p {
  margin: 0 0 6px;
}
.advanced-access-info-panel p:last-child {
  margin-bottom: 0;
}

.restricted-access-tabs {
  margin-bottom: 8px;
}

.restricted-tab-bar {
  display: flex;
  gap: 0;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 8px;
}
.restricted-tab-bar.access-mode-bar {
  margin-bottom: 16px;
}
.restricted-tab-bar button {
  flex: 1;
  padding: 10px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: "Raleway", sans-serif;
  font-weight: 600;
  font-size: 0.9rem;
  color: #64748b;
  border-bottom: 2px solid transparent;
  outline: none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  -webkit-tap-highlight-color: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.restricted-tab-bar button:focus, .restricted-tab-bar button:focus-visible, .restricted-tab-bar button:active {
  outline: none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  border: none;
  border-bottom: 2px solid transparent;
}
.restricted-tab-bar button.active {
  color: #5ea1d8;
  border-bottom: 2px solid #5ea1d8;
}
.restricted-tab-bar button.active:focus, .restricted-tab-bar button.active:focus-visible, .restricted-tab-bar button.active:active {
  outline: none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  border: none;
  border-bottom: 2px solid #5ea1d8;
}

.access-switch {
  flex-shrink: 0;
  width: 44px;
  height: 24px;
  border-radius: 12px;
  border: none;
  padding: 0;
  cursor: pointer;
  background: #cbd5e1;
  position: relative;
  transition: background-color 0.15s ease;
}
.access-switch::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  transition: transform 0.15s ease;
}
.access-switch.is-on {
  background: #5ea1d8;
}
.access-switch.is-on::after {
  transform: translateX(20px);
}
.access-switch:focus-visible {
  outline: 2px solid #5ea1d8;
  outline-offset: 2px;
}

.tab-pane {
  padding: 12px 4px 8px;
}

.advanced-access-section {
  margin: 8px 0;
  padding: 4px 0;
}

.access-option-card {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  padding: 12px 14px;
  margin: 0 0 12px;
  background: #fafafa;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.access-option-card.active {
  border-color: #5ea1d8;
  background: #f3f9fd;
}

.access-option-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.access-option-title {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
  flex: 1;
}
.access-option-title mat-icon {
  flex: 0 0 24px;
  width: 24px !important;
  height: 24px !important;
  min-width: 24px;
  font-size: 24px !important;
  line-height: 24px !important;
  margin-top: 2px;
  color: #5ea1d8;
  overflow: visible;
}
.access-option-title > div {
  min-width: 0;
  flex: 1;
}
.access-option-title strong {
  display: block;
  font-size: 0.95rem;
}
.access-option-title span {
  display: block;
  font-size: 0.8rem;
  opacity: 0.75;
  margin-top: 2px;
}

.access-option-body {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}
.access-option-body input.advanced-input {
  transition: border-color 0.15s ease !important;
}

.field-label {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 6px;
}

.field-help {
  margin: 8px 0 0;
  font-size: 0.78rem;
  opacity: 0.8;
}
.field-help code {
  font-size: 0.75rem;
}

.add-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.add-row .grow {
  flex: 1;
}
.add-row button {
  margin-top: 4px;
  height: 40px;
}

.advanced-input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 14px;
  font-family: "Raleway", sans-serif;
  background: #fff;
  color: #1e293b;
  transition: border-color 0.15s ease !important;
  margin: 0;
}
.advanced-input:focus {
  outline: none;
  border-color: #5ea1d8;
  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.15);
}

.geo-field {
  display: flex;
  flex: 1 1 120px;
  flex-direction: column;
  gap: 4px;
  min-width: 120px;
}
.geo-field span {
  font-size: 0.75rem;
  font-weight: 600;
  opacity: 0.85;
}

.value-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.entry-chip {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  max-width: 100%;
  padding: 4px 8px 4px 10px;
  border-radius: 16px;
  background: #d8e4f7;
  color: #1a3a6b;
  font-size: 12px;
  word-break: break-all;
}
.entry-chip button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  margin-left: 2px;
  color: inherit;
  opacity: 0.75;
}
.entry-chip button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.entry-chip button:hover {
  opacity: 1;
}

.location-btn {
  margin-top: 4px;
}

body.theme-dark .enhanced-restricted-access-dialog .upgrade-required-banner {
  background: #1a2c3d;
  border-color: rgba(94, 161, 216, 0.35);
}
body.theme-dark .enhanced-restricted-access-dialog .upgrade-required-banner .upgrade-required-copy strong,
body.theme-dark .enhanced-restricted-access-dialog .upgrade-required-banner .upgrade-required-copy p {
  color: #e2e8f0;
}
body.theme-dark .enhanced-restricted-access-dialog .locked-advanced-card {
  background: #17212f;
  border-color: rgba(94, 161, 216, 0.45);
}
body.theme-dark .enhanced-restricted-access-dialog .restricted-tab-bar button {
  color: #94a3b8;
}
body.theme-dark .enhanced-restricted-access-dialog .restricted-tab-bar button.active {
  color: #7ec8f0;
  border-bottom-color: #5ea1d8;
}
body.theme-dark .enhanced-restricted-access-dialog .feature-info-btn {
  color: #7ec8f0;
}
body.theme-dark .enhanced-restricted-access-dialog .feature-info-btn:hover {
  color: #5ea1d8;
}
body.theme-dark .enhanced-restricted-access-dialog .advanced-access-info-panel {
  background: #1a2c3d;
  border-color: rgba(94, 161, 216, 0.35);
  color: #cbd5e1;
}
body.theme-dark .enhanced-restricted-access-dialog .users-advanced-nudge {
  color: #94a3b8;
}
body.theme-dark .enhanced-restricted-access-dialog .users-advanced-nudge .nudge-link {
  color: #7ec8f0;
}
body.theme-dark .enhanced-restricted-access-dialog .users-advanced-nudge .nudge-link:hover {
  color: #5ea1d8;
}
body.theme-dark .enhanced-restricted-access-dialog .access-switch {
  background: #475569;
}
body.theme-dark .enhanced-restricted-access-dialog .access-switch.is-on {
  background: #5ea1d8;
}
body.theme-dark .enhanced-restricted-access-dialog .access-option-card {
  background: #1a2332;
  border-color: #334155;
}
body.theme-dark .enhanced-restricted-access-dialog .access-option-card.active {
  background: #1e293b;
  border-color: #5ea1d8;
}
body.theme-dark .enhanced-restricted-access-dialog .access-option-body {
  border-top-color: #334155;
}
body.theme-dark .enhanced-restricted-access-dialog .advanced-input {
  background: #1f2937;
  border-color: #475569;
  color: #e2e8f0;
}
body.theme-dark .enhanced-restricted-access-dialog .radius-unit-toggle {
  border-color: #475569;
}
body.theme-dark .enhanced-restricted-access-dialog .radius-unit-toggle button {
  background: #1f2937;
  color: #cbd5e1;
}
body.theme-dark .enhanced-restricted-access-dialog .radius-unit-toggle button.active {
  background: #5ea1d8;
  color: #fff;
}
body.theme-dark .enhanced-restricted-access-dialog .entry-chip {
  background: #1e3a5f;
  color: #e2e8f0;
}

.advanced-access-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 4px;
}
.advanced-access-header h3 {
  margin: 0;
  font-size: 1rem;
}

.upgrade-required-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  margin: 0 0 14px;
  border-radius: 10px;
  border: 1px solid rgba(94, 161, 216, 0.45);
  background: #eef6fc;
}
.upgrade-required-banner.is-highlighted {
  border-color: #5ea1d8;
  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.25);
}
.upgrade-required-banner mat-icon {
  color: #5ea1d8;
  flex-shrink: 0;
  margin-top: 2px;
}
.upgrade-required-banner .upgrade-required-copy {
  flex: 1;
  min-width: 0;
}
.upgrade-required-banner .upgrade-required-copy strong {
  display: block;
  font-size: 0.92rem;
  margin-bottom: 4px;
}
.upgrade-required-banner .upgrade-required-copy p {
  margin: 0 0 10px;
  font-size: 0.82rem;
  line-height: 1.45;
  opacity: 0.9;
  display: block;
  text-align: left;
}
.upgrade-required-banner .upgrade-inline-btn {
  margin-top: 2px;
}

.locked-advanced-card {
  margin: 0 0 14px;
  padding: 14px;
  border: 1px dashed rgba(94, 161, 216, 0.55);
  border-radius: 10px;
  background: #f8fbfe;
  overflow: visible;
  position: relative;
  z-index: 1;
}
.locked-advanced-card .access-option-title mat-icon {
  flex: 0 0 24px;
  width: 24px !important;
  height: 24px !important;
  min-width: 24px;
  font-size: 24px !important;
  line-height: 24px !important;
  color: #5ea1d8;
  position: relative;
  z-index: 2;
}

.locked-advanced-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.locked-advanced-head .access-option-title {
  flex: 1 1 220px;
  min-width: 0;
}
.locked-advanced-head .btn,
.locked-advanced-head .btn-primary {
  flex: 0 0 auto;
  white-space: nowrap;
  align-self: center;
}

.access-option-card.is-locked {
  opacity: 0.92;
  cursor: pointer;
}
.access-option-card.is-locked .access-option-title span {
  opacity: 0.65;
}

.users-section.is-locked,
.selection-menu.is-locked {
  cursor: pointer;
  position: relative;
}

.access-switch.is-locked {
  cursor: pointer;
  background: #e2e8f0;
}
.access-switch.is-locked::after {
  box-shadow: none;
}
.access-switch.is-locked:hover {
  background: #cbd5e1;
}

.advanced-access-hint {
  margin: 0 0 12px;
  font-size: 0.875rem;
  opacity: 0.8;
}

.users-advanced-nudge {
  margin: 0 0 12px;
  font-size: 0.875rem;
  color: #475569;
  line-height: 1.45;
}
.users-advanced-nudge .nudge-link {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  color: #5ea1d8;
  font-weight: 600;
  font-size: inherit;
  font-family: inherit;
  cursor: pointer;
  text-decoration: underline;
}
.users-advanced-nudge .nudge-link:hover {
  color: #4a8fc4;
}
.users-advanced-nudge .nudge-link:focus, .users-advanced-nudge .nudge-link:focus-visible {
  outline: none;
}

.advanced-field {
  width: 100%;
  display: block;
  margin-top: 8px;
}

.geo-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.geo-coords-row {
  margin-bottom: 0;
}

.geo-radius-row {
  width: 100%;
  margin-top: 8px;
}

.geo-radius-field {
  flex: 1 1 100%;
  min-width: 0;
  width: 100%;
}

.geo-radius-input-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.geo-radius-input-row .advanced-input {
  flex: 1 1 140px;
  min-width: 120px;
}

.radius-unit-toggle {
  display: inline-flex;
  align-items: stretch;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  overflow: hidden;
  flex: 0 0 auto;
}
.radius-unit-toggle button {
  border: none;
  background: #f8fafc;
  color: #475569;
  padding: 8px 12px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  outline: none !important;
  box-shadow: none !important;
  line-height: 1.2;
}
.radius-unit-toggle button.active {
  background: #5ea1d8;
  color: #fff;
}
.radius-unit-toggle button:focus, .radius-unit-toggle button:focus-visible, .radius-unit-toggle button:active {
  outline: none !important;
  box-shadow: none !important;
}

.advanced-field-sm {
  flex: 1 1 120px;
  min-width: 120px;
}

.advanced-error {
  margin-top: 8px;
  color: #c62828;
  font-size: 0.875rem;
}

.advanced-access-section mat-checkbox {
  display: block;
  margin-top: 10px;
}

.device-id-hint {
  margin: 6px 0 0;
  font-size: 0.8rem;
  opacity: 0.85;
}
.device-id-hint code {
  display: inline-block;
  margin-left: 4px;
  word-break: break-all;
}

.enhanced-restricted-access-dialog .btn-primary,
.enhanced-restricted-access-dialog button.btn-primary,
.enhanced-restricted-access-dialog .btn.btn-primary {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: #5ea1d8;
  color: #ffffff;
  text-transform: none;
  letter-spacing: 0;
}
.enhanced-restricted-access-dialog .btn-primary:hover:not(:disabled),
.enhanced-restricted-access-dialog button.btn-primary:hover:not(:disabled),
.enhanced-restricted-access-dialog .btn.btn-primary:hover:not(:disabled) {
  background: #4a8fc4;
}
.enhanced-restricted-access-dialog .btn-primary:disabled,
.enhanced-restricted-access-dialog button.btn-primary:disabled,
.enhanced-restricted-access-dialog .btn.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.enhanced-restricted-access-dialog .btn-secondary,
.enhanced-restricted-access-dialog button.btn-secondary,
.enhanced-restricted-access-dialog .btn.btn-secondary {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: #f3f4f6;
  color: #374151;
}
.enhanced-restricted-access-dialog .btn-secondary:hover:not(:disabled),
.enhanced-restricted-access-dialog button.btn-secondary:hover:not(:disabled),
.enhanced-restricted-access-dialog .btn.btn-secondary:hover:not(:disabled) {
  background: #e5e7eb;
}
.enhanced-restricted-access-dialog .btn-secondary:disabled,
.enhanced-restricted-access-dialog button.btn-secondary:disabled,
.enhanced-restricted-access-dialog .btn.btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.enhanced-restricted-access-dialog .location-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
}

/* Embedded (journey Access tab) — no dialog chrome / height caps */
:host {
  display: block;
  width: 100%;
  text-align: left;
  max-height: none;
  overflow: visible;
}

.enhanced-restricted-access-dialog.embedded-access {
  text-align: left;
  max-height: none !important;
  height: auto !important;
  overflow: visible !important;
  width: 100% !important;
  max-width: none !important;
}
.enhanced-restricted-access-dialog.embedded-access.responsive-popup-container,
.enhanced-restricted-access-dialog.embedded-access .responsive-popup-container {
  max-width: none !important;
  max-height: none !important;
  height: auto !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  overflow: visible !important;
  display: block !important;
}
.enhanced-restricted-access-dialog.embedded-access .responsive-popup-box {
  max-width: none !important;
  max-height: none !important;
  height: auto !important;
  min-height: 0 !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible !important;
  display: block !important;
}
.enhanced-restricted-access-dialog.embedded-access .responsive-popup-content {
  max-width: none !important;
  max-height: none !important;
  height: auto !important;
  min-height: 0 !important;
  overflow: visible !important;
  padding: 0 !important;
  flex: none !important;
  width: 100% !important;
}
.enhanced-restricted-access-dialog.embedded-access .responsive-popup-box-wrap,
.enhanced-restricted-access-dialog.embedded-access .responsive-popup-des-box {
  width: 100% !important;
  max-width: 100% !important;
  max-height: none !important;
  margin: 0 !important;
  padding: 0 !important;
  text-align: left !important;
  overflow: visible !important;
  display: block !important;
}
.enhanced-restricted-access-dialog.embedded-access .restricted-tab-bar,
.enhanced-restricted-access-dialog.embedded-access .tab-pane,
.enhanced-restricted-access-dialog.embedded-access .selection-menu {
  width: 100% !important;
  max-width: 100% !important;
}
.enhanced-restricted-access-dialog.embedded-access .or-access-hint,
.enhanced-restricted-access-dialog.embedded-access .restricted-tab-bar,
.enhanced-restricted-access-dialog.embedded-access .selection-menu,
.enhanced-restricted-access-dialog.embedded-access .tab-pane,
.enhanced-restricted-access-dialog.embedded-access .access-option-card,
.enhanced-restricted-access-dialog.embedded-access .access-option-body {
  text-align: left;
  max-height: none !important;
  overflow: visible !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/enhanced-restricted-access/enhanced-restricted-access.component.scss","webpack://./src/app/shared/styles/responsive-popup.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;6CAAA;AAIA,oDAAA;AACA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EAGA,kBAAA;EACA,WAAA;EACA,YAAA;ADDF;;ACIA,0CAAA;AACA;EACE,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EAEA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,uCAAA;EACA,mCAAA;EACA,yBAAA;EACA,+BAAA;EACA,qBAAA;EACA,wCAAA;UAAA,gCAAA;ADFF;;ACKA,6BAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;ADFF;ACIE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;ADFJ;ACKE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kCAAA;EACA,uBAAA;EACA,gBAAA;ADHJ;;ACOA,4BAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sCAAA;ADJF;ACME;EACE,oCAAA;ADJJ;ACOE;EACE,eAAA;EACA,WAAA;EACA,YAAA;ADLJ;;ACSA,4BAAA;AACA;EACE,OAAA;EACA,gBAAA;EACA,2BAAA;EACA,aAAA;EACA,iCAAA;ADNF;;ACSA,2BAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;ADNF;;ACSA,+BAAA;AACA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;ADNF;ACQE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;ADNJ;;ACUA,yBAAA;AACA;EACE,yBAAA;EACA,WAAA;ADPF;ACSE;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;ADPJ;ACUE;EACE,WAAA;EACA,YAAA;ADRJ;ACWE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;ADTJ;ACYE;EACE,iBAAA;ADVJ;;ACcA,8BAAA;AACA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;ADXF;ACaE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;ADXJ;ACaI;EACE,eAAA;EACA,WAAA;EACA,YAAA;ADXN;ACcI;EACE,YAAA;EACA,mBAAA;ADZN;ACgBE;EACE,mBAAA;EACA,WAAA;EACA,sBAAA;ADdJ;ACgBI;EACE,mBAAA;ADdN;ACkBE;EACE,mBAAA;EACA,YAAA;ADhBJ;ACkBI;EACE,mBAAA;EACA,2BAAA;EACA,8CAAA;ADhBN;ACoBE;EACE,mBAAA;EACA,YAAA;ADlBJ;ACoBI;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;ADlBN;ACsBE;EACE,mBAAA;EACA,YAAA;ADpBJ;ACsBI;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;ADpBN;;ACyBA;;6CAAA;AAIA,uCAAA;AACA;EACE;IACE,2BAAA;IACA,gBAAA;IACA,iCAAA;EDvBF;EC0BA;IACE,0BAAA;IACA,sBAAA;IACA,6BAAA;IACA,4BAAA;IACA,6BAAA;IACA,oBAAA;IACA,qBAAA;IACA,0BAAA;IACA,2BAAA;IACA,kBAAA;EDxBF;EC2BA;IACE,kBAAA;IACA,gBAAA;EDzBF;EC2BE;IACE,eAAA;IACA,gBAAA;EDzBJ;EC4BE;IACE,eAAA;IACA,WAAA;IACA,YAAA;ED1BJ;EC8BA;IACE,eAAA;IACA,gBAAA;IACA,YAAA;IACA,kCAAA;IACA,uBAAA;IACA,2BAAA;ED5BF;EC8BE;IACE,eAAA;IACA,WAAA;IACA,YAAA;ED5BJ;ECgCA;IACE,aAAA;IACA,8BAAA;IACA,gBAAA;IACA,iCAAA;ED9BF;ECiCA;IACE,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,SAAA;IACA,mBAAA;IACA,6BAAA;IACA,aAAA;IACA,SAAA;IACA,uBAAA;IACA,mBAAA;ED/BF;ECiCE;IACE,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,kBAAA;ED/BJ;ECiCI;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;ED/BN;AACF;ACoCA,2CAAA;AACA;EACE;IACE,2BAAA;IACA,gBAAA;IACA,iCAAA;EDlCF;ECqCA;IACE,0BAAA;IACA,sBAAA;IACA,6BAAA;IACA,4BAAA;IACA,6BAAA;IACA,oBAAA;IACA,qBAAA;IACA,0BAAA;IACA,kBAAA;EDnCF;ECsCA;IACE,kBAAA;IACA,gBAAA;EDpCF;ECsCE;IACE,eAAA;IACA,gBAAA;EDpCJ;ECuCE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EDrCJ;ECyCA;IACE,eAAA;IACA,gBAAA;IACA,aAAA;IACA,kCAAA;IACA,uBAAA;IACA,2BAAA;EDvCF;ECyCE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EDvCJ;EC2CA;IACE,aAAA;IACA,8BAAA;IACA,gBAAA;IACA,iCAAA;EDzCF;EC4CA;IACE,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,SAAA;IACA,mBAAA;IACA,6BAAA;IACA,aAAA;IACA,QAAA;IACA,uBAAA;IACA,mBAAA;ED1CF;EC4CE;IACE,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;ED1CJ;EC4CI;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;ED1CN;AACF;AC+CA;;6CAAA;AAIA,iCAAA;AACA;EACE;IACE,4BAAA;IACA,gBAAA;IACA,iCAAA;ED9CF;ECiDA;IACE,2BAAA;IACA,sBAAA;IACA,0BAAA;IACA,2BAAA;IACA,iCAAA;ED/CF;ECkDA;IACE,8BAAA;IACA,gBAAA;IACA,iCAAA;EDhDF;ECmDA;IACE,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,SAAA;EDjDF;AACF;ACoDA;;6CAAA;AAIA,8CAAA;AAEE;EACE,qCAAA;EACA,8BAAA;ADpDJ;ACuDE;;;EAGE,wBAAA;EACA,4BAAA;EACA,2BAAA;ADrDJ;ACyDE;EACE,oDAAA;EACA,yBAAA;ADvDJ;AC2DE;EACE,yBAAA;EAGA,iBAAA;ADzDJ;AC6DE;EACE,uBAAA;EACA,iCAAA;AD3DJ;;AC+DA;;6CAAA;AAIA;yEAAA;AAEA;EACE,8BAAA;EACA,yBAAA;AD7DF;;ACgEA;EACE,8BAAA;EACA,yBAAA;EACA,wDAAA;AD7DF;;ACgEA;EACE,8BAAA;EACA,yBAAA;AD7DF;;ACgEA;EACE,8BAAA;EACA,yBAAA;AD7DF;;ACgEA;;EAEE,8BAAA;AD7DF;;ACgEA;EACE,8BAAA;EACA,qDAAA;AD7DF;;ACgEA;;6CAAA;AAIA;EACE;IACE,yBAAA;ED9DF;ECiEA;IACE,gCAAA;ED/DF;ECkEA;IACE,6BAAA;EDhEF;AACF;ACmEA;;6CAAA;AAIA;EAEI;IACE,qCAAA;IACA,uCAAA;IACA,sCAAA;EDnEJ;AACF;ACuEA;;6CAAA;AAIA;EACE,WAAA;EACA,mBAAA;ADtEF;ACwEE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kCAAA;EACA,wBAAA;EACA,gBAAA;ADtEJ;ACwEI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;ADtEN;ACyEI;EACE,WAAA;ADvEN;AC2EE;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;ADzEJ;;AC6EA;;6CAAA;AAKE;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AD5EJ;AC8EI;EACE,yBAAA;AD5EN;AC+EI;EACE,yBAAA;EACA,8BAAA;AD7EN;ACgFI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AD9EN;ACgFM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AD9ER;ACiFM;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AD/ER;ACmFI;EACE,OAAA;EACA,YAAA;ADjFN;ACmFM;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;ADjFR;ACoFM;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADlFR;;ACwFA;;6CAAA;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;ADtFF;ACwFE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;ADtFJ;ACwFI;EACE,mBAAA;EACA,kBAAA;ADtFN;ACyFI;EACE,YAAA;EACA,mBAAA;ADvFN;AC0FI;EACE,eAAA;EACA,WAAA;EACA,YAAA;ADxFN;AC4FE;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,uBAAA;AD1FJ;AC4FI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AD1FN;AC4FM;EACE,mBAAA;EACA,kBAAA;AD1FR;AC6FM;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AD3FR;AC8FM;EACE,YAAA;EACA,mBAAA;AD5FR;;ACkGA;;6CAAA;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;ADhGF;ACkGE;EACE,iBAAA;ADhGJ;;ACoGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;ADjGF;ACmGE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;ADjGJ;;ACqGA;;6CAAA;AAIA;EAAe,kBAAA;ADlGf;;ACmGA;EAAa,gBAAA;AD/Fb;;ACgGA;EAAc,iBAAA;AD5Fd;;AC8FA;EAAU,aAAA;AD1FV;;AC2FA;EAAW,cAAA;ADvFX;;ACwFA;EAAU,aAAA;ADpFV;;ACsFA;EAAsB,mBAAA;ADlFtB;;ACmFA;EAA0B,uBAAA;AD/E1B;;ACgFA;EAA2B,8BAAA;AD5E3B;;AC6EA;EAAuB,yBAAA;ADzEvB;;AC2EA;EAAS,WAAA;ADvET;;ACwEA;EAAS,YAAA;ADpET;;ACsEA;EAAQ,gBAAA;ADlER;;ACmEA;EAAQ,kBAAA;AD/DR;;ACgEA;EAAQ,mBAAA;AD5DR;;AC6DA;EAAQ,mBAAA;ADzDR;;AC2DA;EAAQ,aAAA;ADvDR;;ACwDA;EAAQ,eAAA;ADpDR;;ACqDA;EAAQ,gBAAA;ADjDR;;ACkDA;EAAQ,gBAAA;AD9CR;;ACgDA;EAAO,UAAA;AD5CP;;AC6CA;EAAO,YAAA;ADzCP;;AC0CA;EAAO,aAAA;ADtCP;;ACuCA;EAAO,aAAA;ADnCP;;ACqCA;EAAoB,iBAAA;ADjCpB;;ACkCA;EAAsB,mBAAA;AD9BtB;;ACgCA;EAAc,WAAA;AD5Bd;;AC6BA;EAAgB,cAAA;ADzBhB;;AC0BA;EAAgB,cAAA;ADtBhB;;ACuBA;EAAe,cAAA;ADnBf;;ACoBA;EAAgB,cAAA;ADhBhB;;AAt0BA;;;iEAAA;AAIA;EAwBE,kDAAA;EAMA,gDAAA;EAaA,0EAAA;EAMA,2BAAA;AA4xBF;AA50BE;EACE,8BAAA;EACA,yBAAA;AA80BJ;AA30BE;;EAEE,8BAAA;EACA,yBAAA;AA60BJ;AA10BE;EACE,yBAAA;AA40BJ;AAz0BE;EACE,yBAAA;AA20BJ;AAx0BE;EACE,yBAAA;AA00BJ;AAt0BE;EACE,8BAAA;EACA,iDAAA;AAw0BJ;AAp0BE;;;EAGE,8BAAA;EACA,oCAAA;EACA,yBAAA;AAs0BJ;AAp0BI;;;EACE,8BAAA;AAw0BN;AAn0BE;;EAEE,yBAAA;AAq0BJ;AAj0BE;;EAEE,yBAAA;EACA,qBAAA;AAm0BJ;AAh0BE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAk0BJ;AA/zBE;EACE,yBAAA;AAi0BJ;AA7zBI;EAAqB,yBAAA;AAg0BzB;AA9zBI;EACE,8BAAA;EACA,yBAAA;AAg0BN;AA7zBI;EACE,8BAAA;EACA,iDAAA;AA+zBN;AA9zBM;EAAK,yBAAA;AAi0BX;AA9zBI;EACE,oCAAA;EACA,8BAAA;AAg0BN;AA9zBI;EAAgC,yBAAA;AAi0BpC;AAh0BI;EAAiC,yBAAA;AAm0BrC;AAl0BI;EAA8B,yBAAA;AAq0BlC;AAp0BI;EAAa,yBAAA;AAu0BjB;AAt0BI;;;EAEY,yBAAA;AAy0BhB;AAt0BE;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAw0BJ;AAt0BI;EAAyB,8BAAA;AAy0B7B;AAx0BI;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;AA00BN;AAt0BE;EACE,8BAAA;EACA,gDAAA;EACA,yBAAA;AAw0BJ;;AAp0BA,8EAAA;AAEE;EACE,qBAAA;AAs0BJ;AAn0BE;EACE,4BAAA;AAq0BJ;AAl0BE;EACE,6BAAA;EACA,iBAAA;EACA,gBAAA;AAo0BJ;AAj0BE;EACE,qBAAA;EACA,gBAAA;AAm0BJ;AAh0BE;EACE,qBAAA;EACA,gBAAA;AAk0BJ;AA/zBE;;;;;;;;;;;;;EAaE,gBAAA;AAi0BJ;;AA7zBA,mDAAA;AACA;EACE,mBAAA;AAg0BF;AA/zBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAi0BJ;AAh0BI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AAk0BN;AAh0BI;EACE,WAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,kCAAA;AAk0BN;AAj0BM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAm0BR;AAj0BM;EACE,WAAA;EACA,kCAAA;EACA,gBAAA;AAm0BR;;AA7zBA,wEAAA;AACA;EACE,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAg0BF;AA9zBE;EACE,mBAAA;EACA,kBAAA;AAg0BJ;AA9zBI;EACE,kBAAA;EACA,eAAA;AAg0BN;AA7zBI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AA+zBN;AA5zBI;EACE,SAAA;EACA,YAAA;AA8zBN;AA5zBM;EACE,QAAA;AA8zBR;AA3zBM;EACE,eAAA;EACA,SAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA6zBR;AAxzBE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;AA0zBJ;AAvzBE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAyzBJ;;AArzBA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,gCAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;AAwzBF;AAtzBE;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,WAAA;AAwzBJ;;AApzBA,uFAAA;AACA;;EAEE,qBAAA;EACA,+BAAA;EACA,uBAAA;EACA,qBAAA;AAuzBF;;AApzBA,mGAAA;AACA;EACE,kCAAA;AAuzBF;AArzBE;EACE,qBAAA;AAuzBJ;AApzBE;EACE,wBAAA;EACA,kCAAA;AAszBJ;AAlzBI;EACE,kCAAA;EACA,gBAAA;AAozBN;AAhzBE;EACE,kCAAA;AAkzBJ;;AA9yBA;EACE,WAAA;EACA,gBAAA;AAizBF;AAhzBE;EACE,WAAA;AAkzBJ;;AA9yBA;EACE,WAAA;EACA,gBAAA;AAizBF;AAhzBE;EACE,WAAA;AAkzBJ;;AA9yBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;AAizBF;;AA9yBA;EACE,eAAA;EACA,cAAA;AAizBF;;AA5yBE;;EAEE,YAAA;AA+yBJ;AA5yBE;EACE,YAAA;AA8yBJ;AA3yBM;EACE,kCAAA;EACA,gBAAA;AA6yBR;AAxyBE;EACE,kCAAA;EACA,gBAAA;EACA,YAAA;AA0yBJ;;AAtyBA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,kBAAA;EACA,WAAA;AAyyBF;;AAtyBA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,WAAA;AAyyBF;;AAtyBA;EACE,kCAAA;AAyyBF;AAvyBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAyyBJ;AAxyBI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,WAAA;AA0yBN;AAxyBI;EACE,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AA0yBN;AAtyBE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAwyBJ;AAtyBI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,WAAA;AAwyBN;AAryBI;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAuyBN;AApyBI;EACE,mBAAA;EACA,cAAA;EACA,eAAA;AAsyBN;AApyBM;EACE,mBAAA;AAsyBR;AAnyBM;EACE,cAAA;EACA,YAAA;AAqyBR;AAnyBQ;EACE,UAAA;AAqyBV;AA/xBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AAiyBJ;AA/xBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AAiyBJ;AA/xBE;EACE,mBAAA;AAiyBJ;AAhyBI;EACE,kBAAA;EACA,kBAAA;EACA,sCAAA;AAkyBN;AAhyBI;EACE,yBAAA;AAkyBN;AAhyBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;AAkyBN;AAhyBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAkyBN;AAhyBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAkyBN;AAhyBI;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAkyBN;AAhyBI;EACE,OAAA;EACA,YAAA;AAkyBN;AAhyBI;EACE,gBAAA;EACA,kCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAkyBN;AAhyBI;EACE,kCAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAkyBN;AA/xBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AAiyBJ;AA/xBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAiyBJ;AA/xBE;EACE,mBAAA;AAiyBJ;AA/xBE;EACE,uBAAA;AAiyBJ;AA/xBE;EACE,aAAA;EACA,QAAA;AAiyBJ;AA/xBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAiyBJ;AA/xBE;EACE,mBAAA;EACA,kBAAA;AAiyBJ;AA/xBE;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAiyBJ;;AA7xBA,wDAAA;AACA;EACE,kCAAA;EACA,mBAAA;AAgyBF;AA7xBI;EACE,kCAAA;EACA,gBAAA;EACA,WAAA;AA+xBN;AA5xBI;EACE,kCAAA;EACA,gBAAA;EACA,WAAA;AA8xBN;;AAzxBA,8DAAA;AAEE;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AA2xBJ;AAxxBE;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AA0xBJ;AAvxBE;EACE,cAAA;EACA,aAAA;EACA,gBAAA;AAyxBJ;AAtxBE;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;AAwxBJ;AAtxBI;;EAEE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAwxBN;;AAnxBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;AAsxBF;;AAnxBA;EACE,cAAA;EACA,eAAA;AAsxBF;;AAnxBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAsxBF;AApxBE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAsxBJ;AAnxBE;EACE,eAAA;EACA,cAAA;AAqxBJ;AAlxBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAoxBJ;;AA/wBE;EACE,8BAAA;EACA,gDAAA;AAkxBJ;AA/wBE;;EAEE,yBAAA;AAixBJ;AA9wBE;EACE,yBAAA;AAgxBJ;AA7wBE;EACE,yBAAA;AA+wBJ;;AA3wBA;EACE,aAAA;AA8wBF;;AA3wBA;EACE;IACE,mBAAA;IACA,SAAA;IACA,kBAAA;IACA,kBAAA;IACA,mBAAA;EA8wBF;EA1wBE;IACE,eAAA;EA4wBJ;EAzwBE;IACE,eAAA;EA2wBJ;AACF;AAvwBA,4BAAA;AACA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,cAAA;AAywBF;AAvwBE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAywBJ;;AArwBA,kBAAA;AACA;EACE,kBAAA;EACA,mBAAA;AAwwBF;AAtwBE;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAwwBJ;AArwBE;EACE,WAAA;EACA,eAAA;EACA,SAAA;AAuwBJ;;AAnwBA,mBAAA;AACA;EACE,mBAAA;AAswBF;AApwBE;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;AAswBJ;AApwBI;EACE,qBAAA;AAswBN;AAnwBI;EACE,WAAA;AAqwBN;;AAhwBA,kBAAA;AACA;EACE,mBAAA;AAmwBF;AAjwBE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,iCAAA;AAmwBJ;AAjwBI;EACE,yBAAA;AAmwBN;AAhwBI;EACE,kBAAA;AAkwBN;AA/vBI;EACE,kBAAA;EACA,eAAA;AAiwBN;AA/vBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAiwBR;AA9vBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAgwBR;AA9vBQ;EACE,eAAA;EACA,WAAA;AAgwBV;AA3vBI;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA6vBN;AA3vBM;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AA6vBR;AA1vBM;EACE,WAAA;EACA,eAAA;AA4vBR;AAzvBM;EACE,WAAA;EACA,eAAA;AA2vBR;;AArvBA,oBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AAwvBF;AAtvBE;EACE,iBAAA;AAwvBJ;;AApvBA,mBAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,0BAAA;AAuvBF;AArvBE;EACE,WAAA;AAuvBJ;AApvBE;EACE,yBAAA;EACA,YAAA;AAsvBJ;AApvBI;EACE,sBAAA;EACA,WAAA;AAsvBN;;AAjvBA;EACE,eAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAovBF;;AAjvBA;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,wBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AAovBF;AAlvBE;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;AAovBJ;AAjvBE;EACE,cAAA;AAmvBJ;AAhvBE;EAGE,wBAAA;EACA,2BAAA;AAgvBJ;;AA5uBA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AA+uBF;AA7uBE;EACE,eAAA;AA+uBJ;AA7uBI;EACE,gBAAA;AA+uBN;;AA1uBA;EACE,kBAAA;AA6uBF;;AA1uBA;EACE,aAAA;EACA,MAAA;EACA,gCAAA;EACA,kBAAA;AA6uBF;AA3uBE;EACE,mBAAA;AA6uBJ;AA1uBE;EACE,OAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,oCAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wCAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA4uBJ;AA1uBI;EAGE,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,YAAA;EACA,oCAAA;AA0uBN;AAvuBI;EACE,cAAA;EACA,gCAAA;AAyuBN;AAtuBI;EAGE,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,YAAA;EACA,gCAAA;AAsuBN;;AAjuBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,uCAAA;AAouBF;AAluBE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;EACA,gCAAA;AAouBJ;AAjuBE;EACE,mBAAA;AAmuBJ;AAjuBI;EACE,2BAAA;AAmuBN;AA/tBE;EACE,0BAAA;EACA,mBAAA;AAiuBJ;;AA7tBA;EACE,qBAAA;AAguBF;;AA7tBA;EACE,aAAA;EACA,cAAA;AAguBF;;AA7tBA;EACE,qCAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0DAAA;AAguBF;AA9tBE;EACE,qBAAA;EACA,mBAAA;AAguBJ;;AA5tBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AA+tBF;;AA5tBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,OAAA;AA+tBF;AA7tBE;EACE,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AA+tBJ;AA5tBE;EACE,YAAA;EACA,OAAA;AA8tBJ;AA3tBE;EACE,cAAA;EACA,kBAAA;AA6tBJ;AA1tBE;EACE,cAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AA4tBJ;;AAxtBA;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;AA2tBF;AAztBE;EACE,8CAAA;AA2tBJ;;AAvtBA;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AA0tBF;;AAvtBA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;AA0tBF;AAxtBE;EACE,kBAAA;AA0tBJ;;AAttBA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AAytBF;AAvtBE;EACE,OAAA;AAytBJ;AAttBE;EACE,eAAA;EACA,YAAA;AAwtBJ;;AAptBA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,cAAA;EACA,8CAAA;EACA,SAAA;AAutBF;AArtBE;EACE,aAAA;EACA,qBAAA;EACA,8CAAA;AAutBJ;;AAntBA;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAstBF;AAptBE;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;AAstBJ;;AAltBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AAqtBF;;AAltBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAqtBF;AAntBE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AAqtBJ;AAntBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAqtBN;AAltBI;EACE,UAAA;AAotBN;;AA/sBA;EACE,eAAA;AAktBF;;AA9sBE;EACE,mBAAA;EACA,sCAAA;AAitBJ;AA/sBI;;EAEE,cAAA;AAitBN;AA7sBE;EACE,mBAAA;EACA,sCAAA;AA+sBJ;AA5sBE;EACE,cAAA;AA8sBJ;AA5sBI;EACE,cAAA;EACA,4BAAA;AA8sBN;AA1sBE;EACE,cAAA;AA4sBJ;AA1sBI;EACE,cAAA;AA4sBN;AAxsBE;EACE,mBAAA;EACA,sCAAA;EACA,cAAA;AA0sBJ;AAvsBE;EACE,cAAA;AAysBJ;AAvsBI;EACE,cAAA;AAysBN;AAvsBM;EACE,cAAA;AAysBR;AApsBE;EACE,mBAAA;AAssBJ;AApsBI;EACE,mBAAA;AAssBN;AAlsBE;EACE,mBAAA;EACA,qBAAA;AAosBJ;AAjsBE;EACE,mBAAA;EACA,qBAAA;AAmsBJ;AAhsBE;EACE,yBAAA;AAksBJ;AA/rBE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAisBJ;AA9rBE;EACE,qBAAA;AAgsBJ;AA9rBI;EACE,mBAAA;EACA,cAAA;AAgsBN;AA9rBM;EACE,mBAAA;EACA,WAAA;AAgsBR;AA3rBE;EACE,mBAAA;EACA,cAAA;AA6rBJ;;AAzrBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AA4rBF;AA1rBE;EACE,SAAA;EACA,eAAA;AA4rBJ;;AAxrBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;AA2rBF;AAzrBE;EACE,qBAAA;EACA,8CAAA;AA2rBJ;AAxrBE;EACE,cAAA;EACA,cAAA;EACA,eAAA;AA0rBJ;AAvrBE;EACE,OAAA;EACA,YAAA;AAyrBJ;AAvrBI;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AAyrBN;AAtrBI;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AAwrBN;AAprBE;EACE,eAAA;AAsrBJ;;AAlrBA;EACE,gBAAA;EACA,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AAqrBF;AAnrBE;EACE,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAqrBJ;;AAjrBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAorBF;AAlrBE;EACE,eAAA;EACA,YAAA;AAorBJ;AAjrBE;;EAEE,cAAA;EACA,mBAAA;EACA,kBAAA;AAmrBJ;;AA/qBA;EACE,aAAA;EACA,eAAA;AAkrBF;AAhrBE;EACE,aAAA;AAkrBJ;;AA9qBA;;EAEE,eAAA;EACA,kBAAA;AAirBF;;AA9qBA;EACE,eAAA;EACA,mBAAA;AAirBF;AA/qBE;EACE,gBAAA;AAirBJ;AA9qBE;EACE,mBAAA;AAgrBJ;;AA5qBA;EACE,gBAAA;EACA,mBAAA;EACA,YAAA;AA+qBF;;AA5qBA;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AA+qBF;AA7qBE;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,0BAAA;AA+qBJ;AA7qBI;EACE,cAAA;AA+qBN;AA5qBI;EAEE,aAAA;AA6qBN;;AAxqBA;EACE,WAAA;EACA,cAAA;EACA,eAAA;AA2qBF;;AAxqBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AA2qBF;;AAxqBA;EACE,gBAAA;AA2qBF;;AAxqBA;EACE,WAAA;EACA,eAAA;AA2qBF;;AAxqBA;EACE,cAAA;EACA,YAAA;EACA,WAAA;AA2qBF;;AAxqBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AA2qBF;AAzqBE;EACE,eAAA;EACA,gBAAA;AA2qBJ;;AAvqBA;EACE,oBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA0qBF;AAxqBE;EACE,YAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,2BAAA;EACA,gBAAA;AA0qBJ;AAxqBI;EACE,mBAAA;EACA,WAAA;AA0qBN;AAvqBI;EAGE,wBAAA;EACA,2BAAA;AAuqBN;;AAlqBA;EACE,eAAA;EACA,gBAAA;AAqqBF;;AAlqBA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAqqBF;;AAlqBA;EACE,cAAA;EACA,gBAAA;AAqqBF;;AAlqBA;EACE,eAAA;EACA,iBAAA;EACA,aAAA;AAqqBF;AAnqBE;EACE,qBAAA;EACA,gBAAA;EACA,qBAAA;AAqqBJ;;AAhqBE;;;EAGE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;AAmqBJ;AAjqBI;;;EACE,mBAAA;AAqqBN;AAlqBI;;;EACE,YAAA;EACA,mBAAA;AAsqBN;AAlqBE;;;EAGE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAoqBJ;AAlqBI;;;EACE,mBAAA;AAsqBN;AAnqBI;;;EACE,YAAA;EACA,mBAAA;AAuqBN;AAnqBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAqqBJ;;AAjqBA,mEAAA;AACA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAoqBF;;AAjqBA;EACE,gBAAA;EACA,2BAAA;EACA,uBAAA;EACA,4BAAA;EACA,sBAAA;EACA,0BAAA;AAoqBF;AAlqBE;;EAEE,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;EACA,kCAAA;EACA,4BAAA;EACA,yBAAA;AAoqBJ;AAjqBE;EACE,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,yBAAA;AAmqBJ;AAhqBE;EACE,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,4BAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;AAkqBJ;AA/pBE;;EAEE,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;AAiqBJ;AA9pBE;;;EAGE,sBAAA;EACA,0BAAA;AAgqBJ;AA7pBE;;;;;;EAME,gBAAA;EACA,2BAAA;EACA,4BAAA;AA+pBJ","sourcesContent":["// Import responsive popup styles\n@import '../../shared/styles/responsive-popup.scss';\n\n/* ── Dark mode overrides ─────────────────────────────────────\n   Use body.theme-dark (not :host-context) so rules apply to\n   Material Dialog content rendered in the CDK overlay.\n   ──────────────────────────────────────────────────────────── */\nbody.theme-dark .enhanced-restricted-access-dialog {\n  .selection-option {\n    background: #1a2332 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .selection-option:hover,\n  .selection-option.mat-radio-checked {\n    background: #253347 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .selection-menu h3 {\n    color: #e2e8f0 !important;\n  }\n\n  .option-text strong {\n    color: #e2e8f0 !important;\n  }\n\n  .option-text p {\n    color: #94a3b8 !important;\n  }\n\n  /* Selected users chips (inside .selection-menu) */\n  .selection-menu .selected-users {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  /* Chip container — dark bg with readable text */\n  .selected-users mat-chip-option,\n  .selected-users .mat-mdc-chip,\n  .selected-users .mdc-evolution-chip {\n    background: #1e3a5f !important;\n    background-color: #1e3a5f !important;\n    color: #e2e8f0 !important;\n\n    &:hover {\n      background: #26487a !important;\n    }\n  }\n\n  /* Chip text label (Material renders text inside a span inside the chip) */\n  .selected-users .mdc-evolution-chip__text-label,\n  .selected-users .mat-mdc-chip-action-label {\n    color: #e2e8f0 !important;\n  }\n\n  /* Chip remove (×) button */\n  .selected-users .mat-mdc-chip-remove mat-icon,\n  .selected-users .mat-mdc-chip-remove .mat-icon {\n    color: #94a3b8 !important;\n    opacity: 1 !important;\n  }\n\n  .search-input {\n    background: #1f2937 !important;\n    color: #f8fafc !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .search-icon {\n    color: #94a3b8 !important;\n  }\n\n  .users-section {\n    .section-header h3 { color: #e2e8f0 !important; }\n\n    .pagination-info {\n      background: #1f2937 !important;\n      color: #94a3b8 !important;\n    }\n\n    .selected-users {\n      background: #1f2937 !important;\n      border-color: rgba(148, 163, 184, 0.2) !important;\n      h4 { color: #e2e8f0 !important; }\n    }\n\n    .user-option:hover {\n      background-color: #253347 !important;\n      background: #253347 !important;\n    }\n    .user-option:hover .user-name { color: #e2e8f0 !important; }\n    .user-option:hover .user-email { color: #94a3b8 !important; }\n    .user-option:hover mat-icon { color: #e2e8f0 !important; }\n    .user-name { color: #e2e8f0 !important; }\n    .user-email,\n    .searching-users,\n    .no-users { color: #94a3b8 !important; }\n  }\n\n  .page-btn {\n    background: #1f2937 !important;\n    color: #94a3b8 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n\n    &:hover:not(:disabled) { background: #2d3748 !important; }\n    &.active {\n      background: #5ea1d8 !important;\n      color: #ffffff !important;\n      border-color: #5ea1d8 !important;\n    }\n  }\n\n  .create-flow-notice {\n    background: #1a2c3d !important;\n    border-color: rgba(94, 161, 216, 0.4) !important;\n    color: #7ec8f0 !important;\n  }\n}\n\n/* Fix padding for enhanced-restricted-access dialog (standalone popup only) */\n.enhanced-restricted-access-dialog:not(.embedded-access) {\n  .responsive-popup-container {\n    padding: 0 !important; // Keep container padding 0 as it's handled by content\n  }\n\n  .responsive-popup-box {\n    padding: 0px 25px !important; // Ensure horizontal padding\n  }\n\n  .responsive-popup-content {\n    padding: 16px 24px !important;\n    min-height: 200px;\n    text-align: left;\n  }\n\n  .responsive-popup-box-wrap {\n    padding: 0 !important; // Remove extra padding from wrap\n    text-align: left;\n  }\n\n  .responsive-popup-des-box {\n    padding: 0 !important; // Content padding is handled by responsive-popup-content\n    text-align: left;\n  }\n\n  .analytics-title,\n  .analytics-title h2,\n  .selection-menu,\n  .selection-menu h3,\n  .advanced-access-header,\n  .advanced-access-header h3,\n  .advanced-access-hint,\n  .users-advanced-nudge,\n  .advanced-access-info-panel,\n  .field-label,\n  .field-help,\n  .section-header,\n  .tab-pane {\n    text-align: left;\n  }\n}\n\n/* Match Transfer Ownership styles for users list */\n.search-section {\n  margin-bottom: 24px;\n  .search-input-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n    .search-icon {\n      position: absolute;\n      left: 12px;\n      color: #666;\n      z-index: 1;\n    }\n    .search-input {\n      width: 100%;\n      padding: 12px 12px 12px 44px;\n      border: 2px solid #e0e0e0;\n      border-radius: 8px;\n      font-size: 14px;\n      font-family: \"Raleway\", sans-serif;\n      font-weight: 500;\n      transition: border-color 0.2s ease;\n      &:focus {\n        outline: none;\n        border-color: #5ea1d8;\n        box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);\n      }\n      &::placeholder {\n        color: #999;\n        font-family: \"Raleway\", sans-serif;\n        font-weight: 500;\n      }\n    }\n  }\n}\n\n/* Clean selection menu to avoid gray block - Match profile menu style */\n.selection-menu {\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  padding: 0 0 16px 0;\n  margin: 0 0 12px 0;\n  box-shadow: none;\n\n  &.access-mode-menu {\n    padding-bottom: 8px;\n    margin-bottom: 4px;\n\n    h3 {\n      margin-bottom: 8px;\n      font-size: 14px;\n    }\n\n    .access-mode-radios {\n      display: flex;\n      flex-direction: row;\n      flex-wrap: nowrap;\n      align-items: center;\n      gap: 20px;\n      width: auto;\n      padding: 5px;\n    }\n\n    ::ng-deep .access-mode-radios .mat-mdc-radio-button {\n      margin: 0;\n      padding: 5px;\n\n      .mdc-form-field {\n        gap: 4px;\n      }\n\n      .mdc-label {\n        padding-left: 0;\n        margin: 0;\n        font-family: \"Raleway\", sans-serif;\n        font-size: 14px;\n        font-weight: 600;\n        color: #334155;\n        white-space: nowrap;\n      }\n    }\n  }\n\n  h3 {\n    margin: 0 0 12px 0;\n    font-size: 16px;\n    font-weight: 500;\n    font-family: \"Raleway\", sans-serif;\n    color: #333;\n    text-align: left;\n  }\n\n  mat-radio-group {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 5px;\n  }\n}\n\n.selection-option {\n  display: block;\n  width: 100%;\n  margin-bottom: 5px;\n  padding: 5px;\n  background: #fff;\n  border-radius: 0;\n  border: none;\n  border-left: 2px solid transparent;\n  transition: all 0.5s ease-in-out;\n  position: relative;\n  font-family: \"Raleway\", sans-serif;\n  font-weight: 500;\n  \n  &:before {\n    content: \"\";\n    width: 2px;\n    height: 100%;\n    top: 0px;\n    left: 0px;\n    background: #5ea1d8;\n    position: absolute;\n    transition: width 0.5s ease-in-out;\n    z-index: -1;\n  }\n}\n\n/* Ensure the dialog surface remains fully vivid and clickable like the comment popup */\n::ng-deep .cdk-overlay-pane.dialoguebox .mat-mdc-dialog-container,\n::ng-deep .cdk-overlay-pane.dialoguebox .mat-mdc-dialog-surface {\n  opacity: 1 !important;\n  pointer-events: auto !important;\n  filter: none !important;\n  padding: 0 !important; // Remove Material Dialog default padding\n}\n\n/* Ensure the enhanced-restricted-access dialog has proper padding and matches profile menu style */\n::ng-deep .cdk-overlay-pane.dialoguebox .enhanced-restricted-access-dialog {\n  font-family: \"Raleway\", sans-serif;\n  \n  .responsive-popup-container {\n    padding: 0 !important;\n  }\n\n  .responsive-popup-content {\n    padding: 24px !important;\n    font-family: \"Raleway\", sans-serif;\n  }\n\n  .responsive-popup-header {\n    h2 {\n      font-family: \"Raleway\", sans-serif;\n      font-weight: 500;\n    }\n  }\n\n  button, span, p, h3, h4, div, input, label {\n    font-family: \"Raleway\", sans-serif;\n  }\n}\n\n.selection-option:hover {\n  color: #fff;\n  background: #fff;\n  &:before {\n    width: 100%;\n  }\n}\n\n.selection-option.mat-radio-checked {\n  color: #fff;\n  background: #fff;\n  &:before {\n    width: 100%;\n  }\n}\n\n.option-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 44px;\n  font-family: \"Raleway\", sans-serif;\n  font-weight: 500;\n}\n\n.option-icon {\n  font-size: 22px;\n  color: #5ea1d8;\n}\n\n// Ensure mat-radio-button uses Raleway font\n::ng-deep .enhanced-restricted-access-dialog {\n  mat-radio-group,\n  .mat-mdc-radio-group {\n    padding: 5px;\n  }\n\n  .mat-mdc-radio-button {\n    padding: 5px;\n\n    .mdc-form-field {\n      .mdc-form-field__label {\n        font-family: \"Raleway\", sans-serif;\n        font-weight: 500;\n      }\n    }\n  }\n  \n  mat-radio-button {\n    font-family: \"Raleway\", sans-serif;\n    font-weight: 500;\n    padding: 5px;\n  }\n}\n\n.option-text strong {\n  display: block;\n  width: 100%;\n  text-align: left;\n  font-size: 15px;\n  font-weight: 500;\n  font-family: \"Raleway\", sans-serif;\n  margin-bottom: 4px;\n  color: #333;\n}\n\n.option-text p {\n  margin: 0;\n  text-align: left;\n  font-size: 13px;\n  font-family: \"Raleway\", sans-serif;\n  font-weight: 500;\n  color: #666;\n}\n\n.users-section {\n  font-family: \"Raleway\", sans-serif;\n  \n  .section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n    h3 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 500;\n      font-family: \"Raleway\", sans-serif;\n      color: #333;\n    }\n    .pagination-info {\n      font-size: 12px;\n      font-family: \"Raleway\", sans-serif;\n      font-weight: 500;\n      color: #666;\n      background: #f5f5f5;\n      padding: 4px 8px;\n      border-radius: 12px;\n    }\n  }\n\n  .selected-users {\n    margin-bottom: 20px;\n    padding: 16px;\n    background: #f8f9fa;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n\n    h4 {\n      margin: 0 0 12px 0;\n      font-size: 14px;\n      font-weight: 500;\n      font-family: \"Raleway\", sans-serif;\n      color: #333;\n    }\n\n    mat-chip-listbox {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n    }\n\n    mat-chip-option {\n      background: #d8e4f7;\n      color: #1a3a6b;\n      font-size: 12px;\n\n      &:hover {\n        background: #b8ccee;\n      }\n\n      .mat-mdc-chip-remove {\n        color: #1a3a6b;\n        opacity: 0.7;\n\n        &:hover {\n          opacity: 1;\n        }\n      }\n    }\n  }\n\n  .searching-users {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 32px;\n    color: #666;\n  }\n  .no-users {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 32px;\n    color: #999;\n  }\n  .users-list {\n    margin-bottom: 16px;\n    .user-option {\n      border-radius: 8px;\n      margin-bottom: 8px;\n      transition: background-color 0.2s ease;\n    }\n    .user-option:hover {\n      background-color: #eef2f7;\n    }\n    .user-item {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      padding: 8px 12px;\n      min-width: 0;\n    }\n    .user-avatar {\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      overflow: hidden;\n      flex-shrink: 0;\n    }\n    .avatar-image {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n    .avatar-placeholder {\n      width: 100%;\n      height: 100%;\n      background: linear-gradient(135deg, #5ea1d8 0%, #56baed 100%);\n      color: #fff;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 16px;\n      font-weight: 600;\n    }\n    .user-info {\n      flex: 1;\n      min-width: 0;\n    }\n    .user-name {\n      font-weight: 500;\n      font-family: \"Raleway\", sans-serif;\n      color: #333;\n      margin-bottom: 2px;\n      font-size: 14px;\n    }\n    .user-email {\n      font-family: \"Raleway\", sans-serif;\n      font-weight: 500;\n      color: #666;\n      font-size: 12px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n  .pagination-controls {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 16px;\n  }\n  .nav-btn {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .nav-btn:hover {\n    background: #f5f5f5;\n  }\n  .nav-btn:disabled:hover {\n    background: transparent;\n  }\n  .page-numbers {\n    display: flex;\n    gap: 4px;\n  }\n  .page-btn {\n    min-width: 32px;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: 500;\n    font-family: \"Raleway\", sans-serif;\n    border: 1px solid #e0e0e0;\n    background: #fff;\n    color: #666;\n    transition: all 0.2s ease;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .page-btn:hover:not(:disabled) {\n    background: #f5f5f5;\n    border-color: #ccc;\n  }\n  .page-btn.active {\n    background: #5ea1d8;\n    color: #fff;\n    border-color: #5ea1d8;\n  }\n}\n\n/* Link Access Info Section - Match profile menu style */\n.link-access-info {\n  font-family: \"Raleway\", sans-serif;\n  margin-bottom: 16px;\n  \n  .info-content {\n    h4 {\n      font-family: \"Raleway\", sans-serif;\n      font-weight: 500;\n      color: #333;\n    }\n    \n    p {\n      font-family: \"Raleway\", sans-serif;\n      font-weight: 500;\n      color: #666;\n    }\n  }\n}\n\n/* Footer actions — match create-flow Publish (.btn-primary) */\n.enhanced-restricted-access-dialog {\n  &.responsive-popup-container {\n    max-height: 90vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .responsive-popup-box {\n    max-height: 90vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n  }\n\n  .responsive-popup-content {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n  }\n\n  .responsive-popup-actions {\n    flex-shrink: 0;\n    position: relative;\n    z-index: 6;\n    justify-content: flex-end;\n\n    .btn.btn-primary,\n    .btn-primary {\n      min-height: auto;\n      min-width: auto;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n}\n\n.current-access-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin: 0 0 16px 0;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #eef6fc;\n  border: 1px solid rgba(94, 161, 216, 0.45);\n}\n\n.current-access-icon {\n  color: #1976d2;\n  margin-top: 2px;\n}\n\n.current-access-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n\n  .current-access-kicker {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #1976d2;\n  }\n\n  strong {\n    font-size: 15px;\n    color: #0f172a;\n  }\n\n  p {\n    margin: 0;\n    font-size: 13px;\n    line-height: 1.4;\n    color: #475569;\n  }\n}\n\nbody.theme-dark .enhanced-restricted-access-dialog {\n  .current-access-banner {\n    background: #1a2c3d !important;\n    border-color: rgba(94, 161, 216, 0.4) !important;\n  }\n\n  .current-access-icon,\n  .current-access-copy .current-access-kicker {\n    color: #7ec8f0 !important;\n  }\n\n  .current-access-copy strong {\n    color: #e2e8f0 !important;\n  }\n\n  .current-access-copy p {\n    color: #94a3b8 !important;\n  }\n}\n\n.header-saved-access {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .current-access-banner {\n    align-items: center;\n    gap: 10px;\n    margin: 0 0 14px 0;\n    padding: 10px 12px;\n    border-radius: 12px;\n  }\n\n  .current-access-copy {\n    strong {\n      font-size: 14px;\n    }\n\n    p {\n      font-size: 12px;\n    }\n  }\n}\n\n/* Create Flow Mode Notice */\n.create-flow-notice {\n  background: #e3f2fd;\n  border: 1px solid #5ea1d8;\n  border-radius: 6px;\n  padding: 12px;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-family: \"Raleway\", sans-serif;\n  font-weight: 500;\n  color: #1976d2;\n\n  .notice-icon {\n    color: #5ea1d8;\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n}\n\n/* Title Section */\n.title-section {\n  text-align: center;\n  margin-bottom: 20px;\n\n  h2 {\n    color: #333;\n    margin-bottom: 8px;\n    font-size: 24px;\n    font-weight: 600;\n  }\n\n  p {\n    color: #666;\n    font-size: 14px;\n    margin: 0;\n  }\n}\n\n/* Search Section */\n.search-section {\n  margin-bottom: 20px;\n\n  .search-input {\n    width: 100%;\n    padding: 12px 16px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.3s;\n\n    &:focus {\n      border-color: #5ea1d8;\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n  }\n}\n\n/* Users Section */\n.users-section {\n  margin-bottom: 20px;\n\n  .user-item {\n    display: flex;\n    align-items: center;\n    padding: 12px;\n    border-bottom: 1px solid #eee;\n    transition: background-color 0.2s;\n\n    &:hover {\n      background-color: #f8f9fa;\n    }\n\n    .transfer-checkbox {\n      margin-right: 16px;\n    }\n\n    .user-avatar {\n      margin-right: 16px;\n      cursor: pointer;\n\n      .avatar-image {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        object-fit: cover;\n      }\n\n      .avatar-placeholder {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        background-color: #e0e0e0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        .material-icons {\n          font-size: 24px;\n          color: #666;\n        }\n      }\n    }\n\n    .user-info {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      .user-name {\n        font-weight: 600;\n        color: #333;\n        font-size: 16px;\n      }\n\n      .user-username {\n        color: #666;\n        font-size: 14px;\n      }\n\n      .user-email {\n        color: #999;\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n/* Loading Section */\n.loading-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 20px;\n  color: #666;\n\n  mat-spinner {\n    margin-right: 8px;\n  }\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n\n  .cancel-btn {\n    color: #666;\n  }\n\n  .confirm-btn {\n    background-color: #5ea1d8;\n    color: white;\n\n    &:disabled {\n      background-color: #ccc;\n      color: #666;\n    }\n  }\n}\n\n.or-access-hint {\n  margin: 0 0 6px;\n  font-size: 0.875rem;\n  opacity: 0.9;\n  line-height: 1.35;\n  text-align: left;\n}\n\n.feature-info-btn {\n  border: none;\n  background: transparent;\n  padding: 0;\n  margin: 0 4px 0 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  cursor: pointer;\n  color: #5ea1d8;\n  outline: none !important;\n  box-shadow: none !important;\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  line-height: 1;\n  position: relative;\n  top: -1px;\n\n  mat-icon {\n    width: 16px !important;\n    height: 16px !important;\n    font-size: 16px !important;\n    line-height: 16px !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    overflow: hidden;\n  }\n\n  &:hover {\n    color: #4a8fc4;\n  }\n\n  &:focus,\n  &:focus-visible,\n  &:active {\n    outline: none !important;\n    box-shadow: none !important;\n  }\n}\n\n.advanced-access-info-panel {\n  margin: 0 0 8px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid rgba(94, 161, 216, 0.35);\n  background: #eef6fc;\n  font-size: 0.84rem;\n  line-height: 1.35;\n  color: #334155;\n\n  p {\n    margin: 0 0 6px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.restricted-access-tabs {\n  margin-bottom: 8px;\n}\n\n.restricted-tab-bar {\n  display: flex;\n  gap: 0;\n  border-bottom: 1px solid #e2e8f0;\n  margin-bottom: 8px;\n\n  &.access-mode-bar {\n    margin-bottom: 16px;\n  }\n\n  button {\n    flex: 1;\n    padding: 10px 16px;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    font-family: \"Raleway\", sans-serif;\n    font-weight: 600;\n    font-size: 0.9rem;\n    color: #64748b;\n    border-bottom: 2px solid transparent;\n    outline: none !important;\n    outline-offset: 0 !important;\n    box-shadow: none !important;\n    -webkit-tap-highlight-color: transparent;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n\n    &:focus,\n    &:focus-visible,\n    &:active {\n      outline: none !important;\n      outline-offset: 0 !important;\n      box-shadow: none !important;\n      border: none;\n      border-bottom: 2px solid transparent;\n    }\n\n    &.active {\n      color: #5ea1d8;\n      border-bottom: 2px solid #5ea1d8;\n    }\n\n    &.active:focus,\n    &.active:focus-visible,\n    &.active:active {\n      outline: none !important;\n      outline-offset: 0 !important;\n      box-shadow: none !important;\n      border: none;\n      border-bottom: 2px solid #5ea1d8;\n    }\n  }\n}\n\n.access-switch {\n  flex-shrink: 0;\n  width: 44px;\n  height: 24px;\n  border-radius: 12px;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  background: #cbd5e1;\n  position: relative;\n  transition: background-color 0.15s ease;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background: #fff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n    transition: transform 0.15s ease;\n  }\n\n  &.is-on {\n    background: #5ea1d8;\n\n    &::after {\n      transform: translateX(20px);\n    }\n  }\n\n  &:focus-visible {\n    outline: 2px solid #5ea1d8;\n    outline-offset: 2px;\n  }\n}\n\n.tab-pane {\n  padding: 12px 4px 8px;\n}\n\n.advanced-access-section {\n  margin: 8px 0;\n  padding: 4px 0;\n}\n\n.access-option-card {\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 10px;\n  padding: 12px 14px;\n  margin: 0 0 12px;\n  background: #fafafa;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  &.active {\n    border-color: #5ea1d8;\n    background: #f3f9fd;\n  }\n}\n\n.access-option-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.access-option-title {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  min-width: 0;\n  flex: 1;\n\n  mat-icon {\n    flex: 0 0 24px;\n    width: 24px !important;\n    height: 24px !important;\n    min-width: 24px;\n    font-size: 24px !important;\n    line-height: 24px !important;\n    margin-top: 2px;\n    color: #5ea1d8;\n    overflow: visible;\n  }\n\n  > div {\n    min-width: 0;\n    flex: 1;\n  }\n\n  strong {\n    display: block;\n    font-size: 0.95rem;\n  }\n\n  span {\n    display: block;\n    font-size: 0.8rem;\n    opacity: 0.75;\n    margin-top: 2px;\n  }\n}\n\n.access-option-body {\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n\n  input.advanced-input {\n    transition: border-color 0.15s ease !important;\n  }\n}\n\n.field-label {\n  display: block;\n  font-size: 0.8rem;\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n\n.field-help {\n  margin: 8px 0 0;\n  font-size: 0.78rem;\n  opacity: 0.8;\n\n  code {\n    font-size: 0.75rem;\n  }\n}\n\n.add-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n\n  .grow {\n    flex: 1;\n  }\n\n  button {\n    margin-top: 4px;\n    height: 40px;\n  }\n}\n\n.advanced-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: \"Raleway\", sans-serif;\n  background: #fff;\n  color: #1e293b;\n  transition: border-color 0.15s ease !important;\n  margin: 0;\n\n  &:focus {\n    outline: none;\n    border-color: #5ea1d8;\n    box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.15);\n  }\n}\n\n.geo-field {\n  display: flex;\n  flex: 1 1 120px;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 120px;\n\n  span {\n    font-size: 0.75rem;\n    font-weight: 600;\n    opacity: 0.85;\n  }\n}\n\n.value-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.entry-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  max-width: 100%;\n  padding: 4px 8px 4px 10px;\n  border-radius: 16px;\n  background: #d8e4f7;\n  color: #1a3a6b;\n  font-size: 12px;\n  word-break: break-all;\n\n  button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    padding: 0;\n    margin-left: 2px;\n    color: inherit;\n    opacity: 0.75;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n.location-btn {\n  margin-top: 4px;\n}\n\nbody.theme-dark .enhanced-restricted-access-dialog {\n  .upgrade-required-banner {\n    background: #1a2c3d;\n    border-color: rgba(94, 161, 216, 0.35);\n\n    .upgrade-required-copy strong,\n    .upgrade-required-copy p {\n      color: #e2e8f0;\n    }\n  }\n\n  .locked-advanced-card {\n    background: #17212f;\n    border-color: rgba(94, 161, 216, 0.45);\n  }\n\n  .restricted-tab-bar button {\n    color: #94a3b8;\n\n    &.active {\n      color: #7ec8f0;\n      border-bottom-color: #5ea1d8;\n    }\n  }\n\n  .feature-info-btn {\n    color: #7ec8f0;\n\n    &:hover {\n      color: #5ea1d8;\n    }\n  }\n\n  .advanced-access-info-panel {\n    background: #1a2c3d;\n    border-color: rgba(94, 161, 216, 0.35);\n    color: #cbd5e1;\n  }\n\n  .users-advanced-nudge {\n    color: #94a3b8;\n\n    .nudge-link {\n      color: #7ec8f0;\n\n      &:hover {\n        color: #5ea1d8;\n      }\n    }\n  }\n\n  .access-switch {\n    background: #475569;\n\n    &.is-on {\n      background: #5ea1d8;\n    }\n  }\n\n  .access-option-card {\n    background: #1a2332;\n    border-color: #334155;\n  }\n\n  .access-option-card.active {\n    background: #1e293b;\n    border-color: #5ea1d8;\n  }\n\n  .access-option-body {\n    border-top-color: #334155;\n  }\n\n  .advanced-input {\n    background: #1f2937;\n    border-color: #475569;\n    color: #e2e8f0;\n  }\n\n  .radius-unit-toggle {\n    border-color: #475569;\n\n    button {\n      background: #1f2937;\n      color: #cbd5e1;\n\n      &.active {\n        background: #5ea1d8;\n        color: #fff;\n      }\n    }\n  }\n\n  .entry-chip {\n    background: #1e3a5f;\n    color: #e2e8f0;\n  }\n}\n\n.advanced-access-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 4px;\n\n  h3 {\n    margin: 0;\n    font-size: 1rem;\n  }\n}\n\n.upgrade-required-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 14px;\n  margin: 0 0 14px;\n  border-radius: 10px;\n  border: 1px solid rgba(94, 161, 216, 0.45);\n  background: #eef6fc;\n\n  &.is-highlighted {\n    border-color: #5ea1d8;\n    box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.25);\n  }\n\n  mat-icon {\n    color: #5ea1d8;\n    flex-shrink: 0;\n    margin-top: 2px;\n  }\n\n  .upgrade-required-copy {\n    flex: 1;\n    min-width: 0;\n\n    strong {\n      display: block;\n      font-size: 0.92rem;\n      margin-bottom: 4px;\n    }\n\n    p {\n      margin: 0 0 10px;\n      font-size: 0.82rem;\n      line-height: 1.45;\n      opacity: 0.9;\n      display: block;\n      text-align: left;\n    }\n  }\n\n  .upgrade-inline-btn {\n    margin-top: 2px;\n  }\n}\n\n.locked-advanced-card {\n  margin: 0 0 14px;\n  padding: 14px;\n  border: 1px dashed rgba(94, 161, 216, 0.55);\n  border-radius: 10px;\n  background: #f8fbfe;\n  overflow: visible;\n  position: relative;\n  z-index: 1;\n\n  .access-option-title mat-icon {\n    flex: 0 0 24px;\n    width: 24px !important;\n    height: 24px !important;\n    min-width: 24px;\n    font-size: 24px !important;\n    line-height: 24px !important;\n    color: #5ea1d8;\n    position: relative;\n    z-index: 2;\n  }\n}\n\n.locked-advanced-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n\n  .access-option-title {\n    flex: 1 1 220px;\n    min-width: 0;\n  }\n\n  .btn,\n  .btn-primary {\n    flex: 0 0 auto;\n    white-space: nowrap;\n    align-self: center;\n  }\n}\n\n.access-option-card.is-locked {\n  opacity: 0.92;\n  cursor: pointer;\n\n  .access-option-title span {\n    opacity: 0.65;\n  }\n}\n\n.users-section.is-locked,\n.selection-menu.is-locked {\n  cursor: pointer;\n  position: relative;\n}\n\n.access-switch.is-locked {\n  cursor: pointer;\n  background: #e2e8f0;\n\n  &::after {\n    box-shadow: none;\n  }\n\n  &:hover {\n    background: #cbd5e1;\n  }\n}\n\n.advanced-access-hint {\n  margin: 0 0 12px;\n  font-size: 0.875rem;\n  opacity: 0.8;\n}\n\n.users-advanced-nudge {\n  margin: 0 0 12px;\n  font-size: 0.875rem;\n  color: #475569;\n  line-height: 1.45;\n\n  .nudge-link {\n    border: none;\n    background: none;\n    padding: 0;\n    margin: 0;\n    color: #5ea1d8;\n    font-weight: 600;\n    font-size: inherit;\n    font-family: inherit;\n    cursor: pointer;\n    text-decoration: underline;\n\n    &:hover {\n      color: #4a8fc4;\n    }\n\n    &:focus,\n    &:focus-visible {\n      outline: none;\n    }\n  }\n}\n\n.advanced-field {\n  width: 100%;\n  display: block;\n  margin-top: 8px;\n}\n\n.geo-fields {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.geo-coords-row {\n  margin-bottom: 0;\n}\n\n.geo-radius-row {\n  width: 100%;\n  margin-top: 8px;\n}\n\n.geo-radius-field {\n  flex: 1 1 100%;\n  min-width: 0;\n  width: 100%;\n}\n\n.geo-radius-input-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n\n  .advanced-input {\n    flex: 1 1 140px;\n    min-width: 120px;\n  }\n}\n\n.radius-unit-toggle {\n  display: inline-flex;\n  align-items: stretch;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  overflow: hidden;\n  flex: 0 0 auto;\n\n  button {\n    border: none;\n    background: #f8fafc;\n    color: #475569;\n    padding: 8px 12px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    cursor: pointer;\n    outline: none !important;\n    box-shadow: none !important;\n    line-height: 1.2;\n\n    &.active {\n      background: #5ea1d8;\n      color: #fff;\n    }\n\n    &:focus,\n    &:focus-visible,\n    &:active {\n      outline: none !important;\n      box-shadow: none !important;\n    }\n  }\n}\n\n.advanced-field-sm {\n  flex: 1 1 120px;\n  min-width: 120px;\n}\n\n.advanced-error {\n  margin-top: 8px;\n  color: #c62828;\n  font-size: 0.875rem;\n}\n\n.advanced-access-section mat-checkbox {\n  display: block;\n  margin-top: 10px;\n}\n\n.device-id-hint {\n  margin: 6px 0 0;\n  font-size: 0.8rem;\n  opacity: 0.85;\n\n  code {\n    display: inline-block;\n    margin-left: 4px;\n    word-break: break-all;\n  }\n}\n\n.enhanced-restricted-access-dialog {\n  .btn-primary,\n  button.btn-primary,\n  .btn.btn-primary {\n    padding: 12px 24px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: none;\n    background: #5ea1d8;\n    color: #ffffff;\n    text-transform: none;\n    letter-spacing: 0;\n\n    &:hover:not(:disabled) {\n      background: #4a8fc4;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  .btn-secondary,\n  button.btn-secondary,\n  .btn.btn-secondary {\n    padding: 12px 24px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: none;\n    background: #f3f4f6;\n    color: #374151;\n\n    &:hover:not(:disabled) {\n      background: #e5e7eb;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  .location-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 8px;\n  }\n}\n\n/* Embedded (journey Access tab) — no dialog chrome / height caps */\n:host {\n  display: block;\n  width: 100%;\n  text-align: left;\n  max-height: none;\n  overflow: visible;\n}\n\n.enhanced-restricted-access-dialog.embedded-access {\n  text-align: left;\n  max-height: none !important;\n  height: auto !important;\n  overflow: visible !important;\n  width: 100% !important;\n  max-width: none !important;\n\n  &.responsive-popup-container,\n  .responsive-popup-container {\n    max-width: none !important;\n    max-height: none !important;\n    height: auto !important;\n    width: 100% !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    box-shadow: none !important;\n    background: transparent !important;\n    overflow: visible !important;\n    display: block !important;\n  }\n\n  .responsive-popup-box {\n    max-width: none !important;\n    max-height: none !important;\n    height: auto !important;\n    min-height: 0 !important;\n    box-shadow: none !important;\n    border-radius: 0 !important;\n    width: 100% !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    overflow: visible !important;\n    display: block !important;\n  }\n\n  .responsive-popup-content {\n    max-width: none !important;\n    max-height: none !important;\n    height: auto !important;\n    min-height: 0 !important;\n    overflow: visible !important;\n    padding: 0 !important;\n    flex: none !important;\n    width: 100% !important;\n  }\n\n  .responsive-popup-box-wrap,\n  .responsive-popup-des-box {\n    width: 100% !important;\n    max-width: 100% !important;\n    max-height: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    text-align: left !important;\n    overflow: visible !important;\n    display: block !important;\n  }\n\n  .restricted-tab-bar,\n  .tab-pane,\n  .selection-menu {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n\n  .or-access-hint,\n  .restricted-tab-bar,\n  .selection-menu,\n  .tab-pane,\n  .access-option-card,\n  .access-option-body {\n    text-align: left;\n    max-height: none !important;\n    overflow: visible !important;\n  }\n}\n\n","/* ========================================\n   RESPONSIVE POPUP COMPONENTS STYLES\n   ======================================== */\n\n/* Base responsive container for all popup dialogs */\n.responsive-popup-container {\n  padding: 0 !important;\n  max-height: 90vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch; // Smooth scrolling on iOS\n  \n  // Ensure proper positioning on all devices\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n/* Base responsive box for popup content */\n.responsive-popup-box {\n  max-width: 560px;\n  width: 100% !important;\n  margin: 10px;\n  padding: 0px 25px;\n  background: #fff;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  // box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);\n  overflow: hidden;\n  border-radius: 15px 15px 0px 0px;\n  margin: 0px auto;\n  background-repeat: no-repeat !important;\n  background-size: contain !important;\n  background-size: 100% 90%;\n  background-position: top center;\n  opacity: 1 !important;\n  backdrop-filter: none !important;\n}\n\n/* Responsive header styles */\n.responsive-popup-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-left: -25px;\n  margin-right: -25px;\n  padding: 12px 16px;\n  background: #fff !important;\n  color: #333;\n  border-bottom: 1px solid #e0e0e0;\n  position: relative;\n  min-height: 60px; // Ensure adequate touch target\n\n  h2 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    line-height: 1.3;\n  }\n\n  .header-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    color: #333;\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none;\n  }\n}\n\n/* Responsive close button */\n.responsive-popup-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  color: #212427;\n  opacity: 1 !important;\n  z-index: 10;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n  min-width: 44px; // WCAG touch target minimum\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n\n  .close-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n}\n\n/* Responsive content area */\n.responsive-popup-content {\n  flex: 1;\n  overflow-y: auto;\n  background: #fff !important;\n  padding: 24px;\n  -webkit-overflow-scrolling: touch; // Smooth scrolling on iOS\n}\n\n/* Responsive box wrapper */\n.responsive-popup-box-wrap {\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 30px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n/* Responsive description box */\n.responsive-popup-des-box {\n  background: #fff;\n  position: relative;\n  width: 100%;\n\n  &::after {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    border-radius: 0px !important;\n    position: absolute;\n    top: 0;\n    z-index: -1;\n    left: 0;\n    right: 0;\n  }\n}\n\n/* Responsive title box */\n.responsive-popup-title-box {\n  padding: 0px 0px 60px 0px;\n  width: 100%;\n\n  h2 {\n    color: #fff !important;\n    font-size: 18px;\n    font-weight: normal;\n    margin-bottom: 20px;\n    text-align: left;\n  }\n\n  ul {\n    margin: 0px;\n    padding: 0px;\n  }\n\n  ul li {\n    color: #fff;\n    list-style: none;\n    padding: 8px 10px 8px 0px;\n    font-size: 16px;\n    text-align: left;\n  }\n\n  ul li span {\n    margin-right: 8px;\n  }\n}\n\n/* Responsive dialog actions */\n.responsive-popup-actions {\n  padding: 16px 20px;\n  min-height: 60px;\n  position: sticky;\n  bottom: 0;\n  background: #f8f9fa;\n  border-top: 1px solid #e0e0e0;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: nowrap;\n  overflow-x: visible;\n  overflow-y: hidden;\n\n  button {\n    min-height: 48px;\n    min-width: 120px;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 6px;\n    padding: 12px 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    transition: all 0.2s ease;\n    border: none;\n    cursor: pointer;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n  }\n\n  .cancel-btn {\n    background: #f5f5f5;\n    color: #666;\n    border: 1px solid #ddd;\n\n    &:hover:not(:disabled) {\n      background: #e8e8e8;\n    }\n  }\n\n  .primary-btn {\n    background: #5ea1d8;\n    color: white;\n\n    &:hover:not(:disabled) {\n      background: #4a8bc2;\n      transform: translateY(-1px);\n      box-shadow: 0 4px 12px rgba(94, 161, 216, 0.3);\n    }\n  }\n\n  .success-btn {\n    background: #28a745;\n    color: white;\n\n    &:hover:not(:disabled) {\n      background: #218838;\n      transform: translateY(-1px);\n      box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n    }\n  }\n\n  .danger-btn {\n    background: #dc3545;\n    color: white;\n\n    &:hover:not(:disabled) {\n      background: #c82333;\n      transform: translateY(-1px);\n      box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);\n    }\n  }\n}\n\n/* ========================================\n   MOBILE RESPONSIVE BREAKPOINTS\n   ======================================== */\n\n/* Tablet and below (768px and below) */\n@media (max-width: 768px) {\n  .responsive-popup-container {\n    max-height: 95vh !important;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .responsive-popup-box {\n    max-width: 95vw !important;\n    width: 95vw !important;\n    margin: 2.5vh auto !important;\n    padding: 0px 15px !important;\n    position: relative !important;\n    top: auto !important;\n    left: auto !important;\n    transform: none !important;\n    max-height: 90vh !important;\n    border-radius: 8px;\n  }\n\n  .responsive-popup-header {\n    padding: 16px 20px;\n    min-height: 60px;\n\n    h2 {\n      font-size: 18px;\n      line-height: 1.3;\n    }\n\n    .header-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .responsive-popup-close {\n    min-width: 44px;\n    min-height: 44px;\n    padding: 8px;\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n\n    .close-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .responsive-popup-content {\n    padding: 20px;\n    max-height: calc(95vh - 140px);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .responsive-popup-actions {\n    padding: 16px 20px;\n    min-height: 60px;\n    position: sticky;\n    bottom: 0;\n    background: #f8f9fa;\n    border-top: 1px solid #e0e0e0;\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n    align-items: center;\n\n    button {\n      min-height: 48px;\n      min-width: 120px;\n      font-size: 14px;\n      font-weight: 500;\n      border-radius: 6px;\n      padding: 12px 20px;\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n        margin-right: 8px;\n      }\n    }\n  }\n}\n\n/* Small mobile devices (480px and below) */\n@media (max-width: 480px) {\n  .responsive-popup-container {\n    max-height: 95vh !important;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .responsive-popup-box {\n    max-width: 98vw !important;\n    width: 98vw !important;\n    margin: 2.5vh auto !important;\n    padding: 0px 12px !important;\n    position: relative !important;\n    top: auto !important;\n    left: auto !important;\n    transform: none !important;\n    border-radius: 6px;\n  }\n\n  .responsive-popup-header {\n    padding: 12px 16px;\n    min-height: 56px;\n\n    h2 {\n      font-size: 16px;\n      line-height: 1.3;\n    }\n\n    .header-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  .responsive-popup-close {\n    min-width: 44px;\n    min-height: 44px;\n    padding: 10px;\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n\n    .close-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .responsive-popup-content {\n    padding: 16px;\n    max-height: calc(98vh - 120px);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .responsive-popup-actions {\n    padding: 12px 16px;\n    min-height: 56px;\n    position: sticky;\n    bottom: 0;\n    background: #f8f9fa;\n    border-top: 1px solid #e0e0e0;\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n    align-items: center;\n\n    button {\n      min-height: 44px;\n      min-width: 100px;\n      font-size: 13px;\n      padding: 10px 16px;\n\n      mat-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n        margin-right: 6px;\n      }\n    }\n  }\n}\n\n/* ========================================\n   LANDSCAPE ORIENTATION SUPPORT\n   ======================================== */\n\n/* Mobile landscape orientation */\n@media (max-width: 768px) and (orientation: landscape) {\n  .responsive-popup-container {\n    max-height: 100vh !important;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .responsive-popup-box {\n    max-height: 95vh !important;\n    width: 98vw !important;\n    max-width: 98vw !important;\n    margin: 1vh auto !important;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .responsive-popup-content {\n    max-height: calc(95vh - 120px);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .responsive-popup-actions {\n    padding: 12px 16px;\n    min-height: 50px;\n    position: sticky;\n    bottom: 0;\n  }\n}\n\n/* ========================================\n   ACCESSIBILITY IMPROVEMENTS\n   ======================================== */\n\n/* Focus management for better accessibility */\n.responsive-popup-container {\n  *:focus-visible {\n    outline: 2px solid #5ea1d8 !important;\n    outline-offset: 2px !important;\n  }\n\n  .restricted-tab-bar button:focus,\n  .restricted-tab-bar button:focus-visible,\n  .restricted-tab-bar button:active {\n    outline: none !important;\n    outline-offset: 0 !important;\n    box-shadow: none !important;\n  }\n\n  // Better touch feedback\n  button, .clickable {\n    -webkit-tap-highlight-color: rgba(94, 161, 216, 0.2);\n    transition: all 0.2s ease;\n  }\n\n  // Prevent text selection on interactive elements\n  button, .clickable {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n\n  // Improve scroll behavior\n  .responsive-popup-content {\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n/* ========================================\n   DARK MODE SUPPORT\n   ======================================== */\n\n/* Use body.theme-dark directly — more reliable than :host-context\n   for Material Dialog content that renders outside the component tree. */\nbody.theme-dark .responsive-popup-box {\n  background: #111827 !important;\n  color: #e2e8f0 !important;\n}\n\nbody.theme-dark .responsive-popup-header {\n  background: #111827 !important;\n  color: #e2e8f0 !important;\n  border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n}\n\nbody.theme-dark .responsive-popup-content {\n  background: #111827 !important;\n  color: #e2e8f0 !important;\n}\n\nbody.theme-dark .responsive-popup-des-box {\n  background: #111827 !important;\n  color: #e2e8f0 !important;\n}\n\nbody.theme-dark .responsive-popup-des-box::after,\nbody.theme-dark .responsive-popup-des-box::before {\n  background: #111827 !important;\n}\n\nbody.theme-dark .responsive-popup-actions {\n  background: #1f2937 !important;\n  border-top-color: rgba(148, 163, 184, 0.2) !important;\n}\n\n/* ========================================\n   HIGH CONTRAST SUPPORT\n   ======================================== */\n\n@media (prefers-contrast: high) {\n  .responsive-popup-box {\n    border: 2px solid #000000;\n  }\n\n  .responsive-popup-header {\n    border-bottom: 2px solid #000000;\n  }\n\n  .responsive-popup-actions {\n    border-top: 2px solid #000000;\n  }\n}\n\n/* ========================================\n   REDUCED MOTION SUPPORT\n   ======================================== */\n\n@media (prefers-reduced-motion: reduce) {\n  .responsive-popup-container {\n    * {\n      animation-duration: 0.01ms !important;\n      animation-iteration-count: 1 !important;\n      transition-duration: 0.01ms !important;\n    }\n  }\n}\n\n/* ========================================\n   FORM ELEMENTS RESPONSIVE STYLES\n   ======================================== */\n\n.responsive-form-field {\n  width: 100%;\n  margin-bottom: 16px;\n\n  input, textarea, select {\n    width: 100%;\n    min-height: 44px; // WCAG touch target minimum\n    font-size: 16px; // Prevent zoom on iOS\n    padding: 12px 16px;\n    border: 2px solid #e0e0e0;\n    border-radius: 8px;\n    transition: border-color 0.2s ease;\n    -webkit-appearance: none;\n    appearance: none;\n\n    &:focus {\n      outline: none;\n      border-color: #5ea1d8;\n      box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n  }\n\n  textarea {\n    min-height: 80px;\n    resize: vertical;\n    font-family: inherit;\n  }\n}\n\n/* ========================================\n   LIST AND SELECTION RESPONSIVE STYLES\n   ======================================== */\n\n.responsive-list {\n  .list-item {\n    min-height: 60px; // Larger touch targets\n    padding: 12px 16px;\n    border-radius: 8px;\n    margin-bottom: 8px;\n    transition: background-color 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #f8f9fa;\n    }\n\n    &.selected {\n      background-color: #e3f2fd;\n      border-left: 4px solid #5ea1d8;\n    }\n\n    .item-avatar {\n      width: 48px;\n      height: 48px;\n      border-radius: 50%;\n      overflow: hidden;\n      flex-shrink: 0;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n\n      .avatar-placeholder {\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(135deg, #5ea1d8 0%, #56baed 100%);\n        color: white;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 18px;\n        font-weight: 600;\n      }\n    }\n\n    .item-content {\n      flex: 1;\n      min-width: 0;\n\n      .item-title {\n        font-weight: 600;\n        color: #333;\n        margin-bottom: 4px;\n        font-size: 16px;\n        line-height: 1.4;\n      }\n\n      .item-subtitle {\n        color: #666;\n        font-size: 14px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n}\n\n/* ========================================\n   PAGINATION RESPONSIVE STYLES\n   ======================================== */\n\n.responsive-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 16px 0;\n  border-top: 1px solid #e0e0e0;\n  margin-top: 16px;\n\n  .nav-btn {\n    min-width: 44px; // WCAG touch target minimum\n    min-height: 44px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: 1px solid #e0e0e0;\n    color: #666;\n    transition: all 0.2s ease;\n\n    &:hover:not(:disabled) {\n      background: #f5f5f5;\n      border-color: #ccc;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .page-numbers {\n    display: flex;\n    gap: 4px;\n    flex-wrap: wrap;\n    justify-content: center;\n\n    .page-btn {\n      min-width: 44px; // WCAG touch target minimum\n      min-height: 44px;\n      border-radius: 6px;\n      font-size: 14px;\n      font-weight: 500;\n      border: 1px solid #e0e0e0;\n      background: white;\n      color: #666;\n      transition: all 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      &:hover:not(:disabled) {\n        background: #f5f5f5;\n        border-color: #ccc;\n      }\n\n      &.active {\n        background: #5ea1d8;\n        color: white;\n        border-color: #5ea1d8;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n\n/* ========================================\n   LOADING AND EMPTY STATES\n   ======================================== */\n\n.responsive-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 32px;\n  color: #666;\n  font-size: 14px;\n\n  mat-spinner {\n    margin-right: 8px;\n  }\n}\n\n.responsive-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 40px 20px;\n  color: #999;\n  font-size: 14px;\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    color: #ccc;\n  }\n}\n\n/* ========================================\n   UTILITY CLASSES\n   ======================================== */\n\n.text-center { text-align: center; }\n.text-left { text-align: left; }\n.text-right { text-align: right; }\n\n.d-flex { display: flex; }\n.d-block { display: block; }\n.d-none { display: none; }\n\n.align-items-center { align-items: center; }\n.justify-content-center { justify-content: center; }\n.justify-content-between { justify-content: space-between; }\n.justify-content-end { justify-content: flex-end; }\n\n.w-100 { width: 100%; }\n.h-100 { height: 100%; }\n\n.mb-0 { margin-bottom: 0; }\n.mb-1 { margin-bottom: 8px; }\n.mb-2 { margin-bottom: 16px; }\n.mb-3 { margin-bottom: 24px; }\n\n.mt-0 { margin-top: 0; }\n.mt-1 { margin-top: 8px; }\n.mt-2 { margin-top: 16px; }\n.mt-3 { margin-top: 24px; }\n\n.p-0 { padding: 0; }\n.p-1 { padding: 8px; }\n.p-2 { padding: 16px; }\n.p-3 { padding: 24px; }\n\n.font-weight-bold { font-weight: bold; }\n.font-weight-normal { font-weight: normal; }\n\n.text-muted { color: #666; }\n.text-primary { color: #5ea1d8; }\n.text-success { color: #28a745; }\n.text-danger { color: #dc3545; }\n.text-warning { color: #ffc107; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
